// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* ========================================
   글로벌 폰트 정책 (DBeaver 스타일 참고)
   - UI 텍스트: Segoe UI, 12px
   - 코드/데이터: Consolas, 13px
   ======================================== */
:root {
  --color-success-bg: #d4edda;
  --color-success-text: #155724;
  --color-error-bg: #f8d7da;
  --color-error-text: #721c24;
  --color-quiz-success-bg: #e8f5e8;
  --color-quiz-success-border: #c8e6c8;
  --color-quiz-success-text: #2e7d32;
  --color-quiz-fail-bg: #ffebee;
  --color-quiz-fail-border: #ffcdd2;
  --color-quiz-fail-text: #c62828;
  /* 챌린지 주의·성공 패널 — 다크모드에서 흰 상자로 남지 않게 변수로 둔다 (2026-09-19) */
  --color-quiz-warn-bg: #fff3cd;
  --color-quiz-warn-border: #ffeaa7;
  --color-quiz-warn-text: #856404;
  --color-quiz-ok-border: #c3e6c3;
  --color-quiz-selected-bg: #eef2f7;
  --color-quiz-no-data-bg: #fff;
  --color-quiz-no-data-border: #bbb;
  --color-quiz-no-data-text: #333;
  --font-ui: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'Consolas', 'Monaco', 'Courier New', monospace;
  --font-size-ui: 12px;
  --font-size-ui-small: 11px;
  --font-size-mono: 13px;
  --font-size-grid: 12px;
  --font-size-tree: 12px;
  --font-size-tab: 12px;
  --color-text: #333;
  --color-text-secondary: #666;
  --color-text-muted: #999;
  --color-bg: #ffffff;
  --color-bg-secondary: #f5f6f8;
  --color-bg-tertiary: #e8ecf0;
  --color-border: #ddd;
  --color-border-light: #eee;
  --color-header-bg: #ffffff;
  --color-tab-bg: #f0f0f0;
  --color-tab-active: #ffffff;
  --color-grid-header: #f2f2f2;
  --color-grid-border: #ddd;
  --color-overlay-bg: rgba(0, 0, 0, 0.5);
  --color-accent: #3b82f6;
  --color-hover-border: #c4c4c4;
  --color-accent-fg: #2563eb;
  --color-accent-hover: #2563eb;
}

/* 다크모드 */
[data-theme="dark"] {
  --color-success-bg: #1e4620;
  --color-success-text: #81c784;
  --color-error-bg: #5a1e20;
  --color-error-text: #e57373;
  --color-quiz-success-bg: #1b4332;
  --color-quiz-success-border: #2d6a4f;
  --color-quiz-success-text: #74c69d;
  --color-quiz-fail-bg: #4a151b;
  --color-quiz-fail-border: #7a2228;
  --color-quiz-fail-text: #ff8a80;
  --color-quiz-warn-bg: #4a3c0f;
  --color-quiz-warn-border: #6b5514;
  --color-quiz-warn-text: #ffd76e;
  --color-quiz-ok-border: #2d6a4f;
  --color-quiz-selected-bg: #2a3340;
  --color-quiz-no-data-bg: var(--color-bg);
  --color-quiz-no-data-border: var(--color-border);
  --color-quiz-no-data-text: var(--color-text);
  --color-text: #d4d4d4;
  --color-text-secondary: #aaa;
  --color-text-muted: #777;
  --color-bg: #1e1e1e;
  --color-bg-secondary: #252526;
  --color-bg-tertiary: #2d2d2d;
  --color-border: #404040;
  --color-border-light: #333;
  --color-header-bg: #252526;
  --color-tab-bg: #2d2d2d;
  --color-tab-active: #1e1e1e;
  --color-grid-header: #2d2d2d;
  --color-grid-border: #404040;
  --color-input-bg: #3c3c3c;
  --color-input-border: #555;
  --color-hover: #37373d;
  /* 호버는 파란 강조색이 아니라 한 단계 밝은 배경 + 회색 테두리로 한다(사용자 요청 2026-09-13).
     파랑은 "선택됨·주 버튼" 에만 쓴다 — 호버까지 파랗면 무엇이 켜져 있는지 구분이 안 된다. */
  --color-hover-border: #5a5a5a;
  /* 강조색을 **글자·테두리**에 쓸 때의 색. #007acc 는 어두운 배경에서 대비가 낮아 잘 안 보였다
     (사용자 지적 2026-09-13 — 헤더 확대 비율·탐색기 연결 버튼). 채운 버튼 배경은 --color-accent 그대로 */
  --color-accent-fg: #6cb6ff;
  --color-active: #094771;
  --color-accent: #007acc;
  --color-btn-bg: #3c3c3c;
  --color-btn-border: #555;
  --color-modal-bg: #2d2d2d;
  --color-scrollbar-bg: #1e1e1e;
  --color-scrollbar-thumb: #555;
  --color-overlay-bg: rgba(0, 0, 0, 0.6);

  /* react-toastify — 라이브러리 기본 dark 는 #121212 라 앱 표면(#2d2d2d)보다 어둡다.
     떠 있는 알림이 배경보다 가라앉아 보이므로 앱의 모달과 같은 층으로 맞춘다.
     아이콘 기본색(#07bc0c·#e74c3c)은 다크에서 과채도라 앱의 성공/실패 색을 쓴다. */
  --toastify-color-dark: var(--color-modal-bg);
  --toastify-text-color-dark: var(--color-text);
  --toastify-color-progress-dark: var(--color-accent);
  --toastify-icon-color-success: var(--color-success-text);
  --toastify-icon-color-error: var(--color-error-text);
}

/* 알림은 어두운 배경 위에 뜨므로 경계가 있어야 표면으로 읽힌다 */
[data-theme="dark"] .Toastify__toast {
  border: 1px solid var(--color-border);
}

/* 다크모드 전역 오버라이드 — type=checkbox/radio 는 제외해서 color-scheme + accent-color 가 native 위젯 렌더에 정상 작동하게 함. */
[data-theme="dark"] input:not([type="checkbox"]):not([type="radio"]),
[data-theme="dark"] select,
[data-theme="dark"] textarea {
  background: var(--color-input-bg);
  color: var(--color-text);
  border-color: var(--color-input-border);
}
/* 위에서 checkbox/radio 를 제외했으면 **여기서 받아 줘야 한다.** 그 규칙이 없어서 다크모드에
   흰 네모와 밝은 파란 체크가 그대로 떠 있었다(지적 2026-09-19 — 쿼리 챌린지의 난이도·공개
   여부 등 여러 군데). 컴포넌트마다 따로 칠하던 것을 여기 한 곳으로 모은다.
     · color-scheme: dark  → 네모의 배경·테두리를 브라우저가 어두운 쪽으로 그린다
     · accent-color        → 체크됐을 때의 채움색을 앱 강조색에 맞춘다 */
[data-theme="dark"] input[type="checkbox"],
[data-theme="dark"] input[type="radio"] {
  color-scheme: dark;
  accent-color: var(--color-accent-fg);
}
/* 자동 완성 목록(datalist)이 있는 입력 칸 — 그 목록은 브라우저가 그리는 창이라 CSS 로 칠할 수 없고 color-scheme 만 따른다.
   없으면 다크모드에 흰 목록이 뜬다(지적 2026-10-16 — 오라클 성능 분석의 대기 검색) */
[data-theme="dark"] input[list] {
  color-scheme: dark;
}

[data-theme="dark"] input::placeholder,
[data-theme="dark"] textarea::placeholder {
  color: var(--color-text-muted);
}
[data-theme="dark"] input:focus,
[data-theme="dark"] select:focus,
[data-theme="dark"] textarea:focus {
  outline: none;
  border-color: var(--color-accent-fg);
}
[data-theme="dark"] button {
  color: var(--color-text);
}
[data-theme="dark"] pre {
  color: var(--color-text);
}
/* 아이콘+레이블 버튼 — 아이콘(svg)이 글자 기준선에 앉으면 줄 상자가 위로 늘어 레이블이 아래로 치우쳐 보인다.
   인라인 버튼은 아이콘을 글자 가운데에 맞춘다(flex 버튼은 align-items 가 맡으므로 영향 없다). */
button > svg { vertical-align: middle; flex-shrink: 0; }
.detach-inline-btn > svg, .split-collapse-btn > svg { display: block; }
/* CodeMirror 전역 폰트 통일 */
.cm-editor, .cm-content, .cm-line, .cm-gutters {
  font-family: var(--font-mono) !important;
  font-size: var(--font-size-mono) !important;
}

[data-theme="dark"] .cm-editor {
  background: var(--color-bg) !important;
}
[data-theme="dark"] .cm-gutters {
  background: var(--color-bg-secondary) !important;
  border-color: var(--color-border) !important;
  color: var(--color-text-muted) !important;
}
[data-theme="dark"] .cm-content {
  color: var(--color-text) !important;
}
[data-theme="dark"] .cm-activeLine {
  background: rgba(255,255,255,0.04) !important;
}
[data-theme="dark"] .cm-selectionBackground {
  background: #264f78 !important;
}
[data-theme="dark"] .result-grid td {
  color: var(--color-text);
  border-color: var(--color-grid-border);
}
[data-theme="dark"] .result-grid tr:hover td {
  background: var(--color-hover);
}
[data-theme="dark"] .sql-editor-minimap {
  background: rgba(37,37,38,0.85);
  border-color: var(--color-border);
}
[data-theme="dark"] .detach-inline-btn {
  color: var(--color-text-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .detach-inline-btn:hover {
  color: var(--color-text);
  border-color: var(--color-hover-border, #5a5a5a); background: var(--color-hover);}
[data-theme="dark"] .editor-search-bar {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}
[data-theme="dark"] .editor-search-input {
  color: var(--color-text);
}
[data-theme="dark"] .editor-search-nav {
  color: var(--color-text-secondary);
}
[data-theme="dark"] .editor-search-nav:hover {
  background: var(--color-hover);
}
[data-theme="dark"] .detach-rejoin-bar {
  background: #1a3a5c;
  border-color: #264f78;
  color: #6cb6ff;
}
[data-theme="dark"] .split-view-divider {
  background: var(--color-border);
}
[data-theme="dark"] .split-view-divider-handle {
  background: var(--color-text-muted);
}

/* 스크롤바 다크모드 */
[data-theme="dark"] { scrollbar-color: #555 #1e1e1e; }
[data-theme="dark"] * { scrollbar-color: #555 #1e1e1e; }
[data-theme="dark"] ::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }
[data-theme="dark"] ::-webkit-scrollbar-track { background: #1e1e1e; }
[data-theme="dark"] ::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }
[data-theme="dark"] ::-webkit-scrollbar-thumb:hover { background: #666; }
[data-theme="dark"] ::-webkit-scrollbar-corner { background: #1e1e1e; }

/* 에디터 테두리 */
[data-theme="dark"] .codemirror-editor-area { border-color: var(--color-border) !important; }
[data-theme="dark"] .sql-editor-inner-container { background: var(--color-bg); }

/* CodeMirror 세부 다크모드 */
[data-theme="dark"] .cm-scroller { scrollbar-color: #555 #1e1e1e; }
[data-theme="dark"] .cm-scroller::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }
[data-theme="dark"] .cm-scroller::-webkit-scrollbar-track { background: #1e1e1e; }
[data-theme="dark"] .cm-scroller::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }
[data-theme="dark"] .cm-activeLineGutter { background: #264f78 !important; color: #fff !important; }
[data-theme="dark"] .cm-lineNumbers .cm-gutterElement { color: var(--color-text-muted); }
/* CodeMirror 구문 하이라이팅 다크모드 (VS Code Dark+ 색상) */
[data-theme="dark"] .ͼb { color: #9cdcfe !important; }  /* variableName */
[data-theme="dark"] .ͼc { color: #d4d4d4 !important; }  /* comment → 밝은 회색 */
[data-theme="dark"] .ͼd { color: #6a9955 !important; }  /* comment (green) */
[data-theme="dark"] .ͼe { color: #569cd6 !important; }  /* keyword (blue) */
[data-theme="dark"] .ͼf { color: #ce9178 !important; }  /* string (orange) */
[data-theme="dark"] .ͼg { color: #b5cea8 !important; }  /* number (green) */
[data-theme="dark"] .ͼi { color: #c586c0 !important; }  /* operator */
[data-theme="dark"] .ͼl { color: #dcdcaa !important; }  /* function */
[data-theme="dark"] .ͼm { color: #4ec9b0 !important; }  /* typeName */
[data-theme="dark"] .ͼn { color: #569cd6 !important; }  /* keyword */
/* 범용: CodeMirror 하이라이트 토큰 */
[data-theme="dark"] .tok-keyword { color: #569cd6 !important; }
[data-theme="dark"] .tok-string { color: #ce9178 !important; }
[data-theme="dark"] .tok-number { color: #b5cea8 !important; }
[data-theme="dark"] .tok-comment { color: #6a9955 !important; }
[data-theme="dark"] .tok-operator { color: #c586c0 !important; }
[data-theme="dark"] .tok-variableName { color: #9cdcfe !important; }
[data-theme="dark"] .tok-typeName { color: #4ec9b0 !important; }
[data-theme="dark"] .tok-propertyName { color: #9cdcfe !important; }
[data-theme="dark"] .tok-punctuation { color: #d4d4d4 !important; }
[data-theme="dark"] .tok-bracket { color: #ffd700 !important; }

/* 메인 탭(쿼리결과/실행계획/테이블정보) 다크모드 */
[data-theme="dark"] .Resizer.horizontal { background: var(--color-bg-secondary) !important; border-top-color: var(--color-border) !important; border-bottom-color: var(--color-border) !important; }
[data-theme="dark"] .Resizer.horizontal:hover { background: var(--color-hover) !important; }

/* 에디터 바인드변수 영역 */
[data-theme="dark"] .bind-variables-section { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .bind-variables-toggle-header { color: var(--color-text-secondary); }

/* 줌 버튼 다크모드 보완 */
[data-theme="dark"] .result-grid { background: var(--rg-outside-bg-dark, #161616); }
[data-theme="dark"] .result-grid td { background: var(--color-bg); color: var(--color-text); border-color: var(--color-grid-border); }
[data-theme="dark"] .side-panel-area { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .file-tabs-container { background: var(--color-tab-bg); }
.result-grid-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #6b7280;
  background: #fafafa;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
  margin: 8px;
  font-size: 13px;
  min-height: 80px;
}
[data-theme="dark"] .result-grid-empty { color: var(--color-text-muted); background: var(--color-bg); border-color: var(--color-border); }
[data-theme="dark"] .loading-more-indicator { background: var(--color-bg-secondary); color: var(--color-text-secondary); border-color: var(--color-border); }

/* 앱 푸터 */
.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 3px 12px;
  font-size: 10px;
  color: var(--color-text-muted);
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  flex-shrink: 0;
}
.app-footer-sep {
  color: var(--color-border);
}

body, button, input, select, textarea {
  font-family: var(--font-ui);
  font-size: var(--font-size-ui);
  color: var(--color-text);
}

.app-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh / var(--app-zoom, 1));
  font-family: var(--font-ui);
  font-size: var(--font-size-ui);
  background: var(--color-bg);
  color: var(--color-text);
}

.content-area {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden;
  position: relative; /* 토글 버튼의 absolute 위치 기준 */
  /* 헤더 높이만큼 content-area의 시작점을 내리거나, 헤더가 absolute가 아니라면 자연스럽게 밀림 */
  /* App.js 에서 Header 다음이므로, Header 높이만큼 자동으로 밀립니다. */
}

.schema-explorer-area {
  flex: 0 0 280px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--color-border);
  background: var(--color-bg-secondary);
  /* 접기(utils/explorerLayout.js) — 오른쪽 패널(.side-panel-area · AI 에이전트)과 **같은 시간**으로 미닫이처럼 */
  transition: font-size 0.1s, flex-basis 260ms ease;
  overflow: hidden;
  /* SchemaExplorer.module.css 의 .schemaExplorerContainer 에 flex-grow:1 및 min-height:0 설정이 중요 */
  /* 내부 스크롤은 SchemaExplorer 컴포넌트가 담당 */
}

/* 탐색기 본문 — 접혀도 마운트된 채 숨는다(hidden). 남는 높이를 탐색기·책갈피가 나눠 쓴다 */
.schema-explorer-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.schema-explorer-body[hidden] { display: none; }

/* 접힌 탐색기 = 아이콘 띠(사용자 결정 2026-10-10). 폭은 utils/explorerLayout EXPLORER_RAIL_WIDTH 와 같다 */
.schema-explorer-area.collapsed { flex-basis: 32px; }
.explorer-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px 0;
  animation: explorer-rail-in 160ms ease-out;
}
.explorer-rail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-muted, #6b7280);
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}
.explorer-rail-btn:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }
.explorer-rail-btn:first-child { color: var(--color-accent, #2f6fb0); }
@keyframes explorer-rail-in {
  from { opacity: 0; transform: translateX(-3px); }
  to { opacity: 1; transform: none; }
}

/* 편집기+결과 칸 — 오른쪽 패널이 열려도 이보다 좁아지지 않는다(utils/explorerLayout EDITOR_MIN_WIDTH).
   모자라면 패널 쪽이 줄어든다 — 사이드 패널은 flex-shrink 1, 데이터 분석·AI 에이전트는 각자의 min-width 까지 */
.editor-result-column {
  flex: 1 1;
  min-width: 480px;
  display: flex;
  flex-direction: column;
  position: relative;
}

@media (prefers-reduced-motion: reduce) {
  .schema-explorer-area { transition: none; }
  .explorer-rail { animation: none; }
  .explorer-rail-btn { transition: none; }
}

/* 에디터 툴바 액션 아이콘 그룹 (검색 바 옆에 가로로 배치) */
/* 공간이 좁아지면(예: SQL 튜닝 패널 펼침) 아이콘이 자동으로 줄바꿈됨 */
/* 툴바 줄바꿈 — 이 뒤의 도구 창 단추는 늘 다음 줄(EditorToolbarRight). 폭 100% 짜리 빈 칸이 줄을 끊는다 */
.editor-toolbar-break { flex-basis: 100%; height: 0; }
.editor-action-group {
  display: flex;
  flex-wrap: wrap;          /* 공간 부족 시 서브그룹 단위로 다음 줄 */
  align-items: center;
  row-gap: 4px;
  column-gap: 4px;
  min-width: 0;             /* flex 축소 허용 — 이게 있어야 wrap 작동 */
  flex-shrink: 1;
  /* 우측 끝 여백은 사용처의 inline style padding-right 로 적용 (인라인 우선순위 회피) */
}

/* 서브그룹: separator 로 구분된 묶음. 내부는 절대 줄바꿈 금지 (그룹 단위로만 wrap) */
.editor-action-subgroup {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 4px;
  align-items: center;
  white-space: nowrap;
}

/* 오른쪽 정렬 시작점: 이 subgroup 부터 우측 정렬됨 (공간 남을 때)
   wrap 되어 줄이 바뀌면 해당 줄 안에서 우측 정렬 유지 */
.editor-toolbar-editor-part { display: contents; } /* 편집기 쪽 툴바 묶음 — 숨기면 검색~창 분리가 함께 사라진다 */
.editor-action-subgroup.right-align {
  margin-left: auto;
}

.editor-action-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  color: var(--color-text-secondary, #555);
  padding: 0;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
}

.editor-action-btn:hover {
  background: var(--color-hover, #e5e7eb);
  color: var(--color-text, #222);
  border-color: var(--color-border, #ddd);
}

.editor-action-btn:active {
  background: var(--color-bg-tertiary, #d1d5db);
}

/* 토글 ON 상태 (예: 컬럼 선택 모드) */
.editor-action-btn.active {
  background: var(--color-accent, #3b82f6);
  color: #ffffff;
  border-color: var(--color-accent, #3b82f6);
}

.editor-action-btn.active:hover {
  background: var(--color-accent, #2563eb);
  color: #ffffff;
  border-color: var(--color-accent, #2563eb);
  filter: brightness(1.1);
}

/* 가로 방향 구분선 (세로 세로줄) */
.editor-action-sep-v {
  display: inline-block;
  width: 1px;
  height: 16px;
  background: var(--color-border, #ddd);
  margin: 0 4px;
}

/* AA / aa 텍스트 아이콘 */
.editor-action-text {
  font-size: 11px;
  font-weight: 700;
  font-family: Menlo, Monaco, Consolas, monospace;
  line-height: 1;
}

[data-theme="dark"] .editor-action-btn {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .editor-action-btn:hover {
  background: var(--color-hover);
  color: var(--color-text);
  border-color: var(--color-border);
}

[data-theme="dark"] .editor-action-sep-v {
  background: var(--color-border);
}

[data-theme="dark"] .editor-action-btn.active {
  background: var(--color-accent);
  color: #ffffff;
  border-color: var(--color-accent-fg);
}

.main-work-area { /* 기존 .main-content 역할 */
  flex-grow: 1;
  display: flex; /* SplitPane이 이 flex 컨테이너를 채우도록 */
  flex-direction: column; /* 내부 FileTabs와 SplitPane이 세로로 배치되도록 */
  overflow: hidden; /* SplitPane이 스크롤을 관리하도록 */
  /* clip — hidden 은 **코드로는 스크롤된다.** 하위 화면의 scrollIntoView 가 이 칸을 밀어 올려 편집기 툴바 줄이
     화면 위로 사라졌다(2026-10-05). clip 은 스크롤 칸이 아니라 어떤 코드도 밀 수 없다(미지원이면 위 hidden). */
  overflow: clip;
  min-width: 0;     /* flex-row 부모(.content-area)의 자식이 콘텐츠(테이블) 폭만큼 늘어나는 것을 방지 — 결과 그리드의 overflow:auto 가로 스크롤 동작 보장. */
  /* padding: 0; */ /* 내부 컴포넌트가 전체 영역을 사용하도록 패딩 조정 */
}

/* FileTabs를 위한 컨테이너 스타일 추가 */
.file-tabs-container {
  flex-shrink: 0; /* 탭 영역은 줄어들지 않음 */
  /* padding: 5px 10px; */ /* 탭 내부 패딩은 FileTabs.module.css에서 관리 */
  /* border-bottom: 1px solid #ccc; */ /* 탭과 에디터 구분선, FileTabs.module.css에 포함하는게 나을수도 있음 */
  background-color: #f0f0f0; /* 탭 영역 배경색 구분 (선택적) */
  /* min-height: 40px; */ /* 탭 높이 확보, FileTabs.module.css에서 구체적 높이 설정 권장 */
  z-index: 10; /* SplitPane 구분선(z-index:5) 보다 높게 설정하여 가려지지 않도록 */
  position: relative; /* z-index 적용을 위해 */
}

.split-pane-container { /* SplitPane을 감싸는 컨테이너 */
  flex-grow: 1;
  display: flex; /* 내부 SplitPane이 100% 크기를 가지도록 */
  min-height: 0; /* flex 아이템이 수축할 수 있도록 */
  min-width: 0;  /* flex-column 부모(.main-work-area)에서 자식이 콘텐츠 폭만큼 늘어나는 것을 방지. */
  position: relative; /* Resizer가 올바르게 동작하도록 */
}

/* ───── 커스텀 툴팁 (portal 방식) ─────
   App.js 에서 [title] → [data-tooltip] 전역 이전 + JS 가 document.body 에 .app-portal-tooltip 띄움.
   부모의 overflow:hidden / clipping context 영향 안 받음 (그리드 셀, CM gutter marker 등 안전).
   위치는 JS 가 계산 — left/top 인라인 스타일로 설정. 좌/우/하단 뷰포트 jam 시 clamp/flip. */
.app-portal-tooltip {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(40, 40, 40, 0.95);
  color: #f5f5f5;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
  font-size: 11px;
  font-weight: normal;
  line-height: 1.35;
  padding: 4px 8px;
  border-radius: 3px;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 360px;
  width: max-content;
  pointer-events: none;
  z-index: 10000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  opacity: 0;
  visibility: hidden;
  transition: opacity 80ms ease-out;
}
.app-portal-tooltip.visible {
  opacity: 1;
  visibility: visible;
}
[data-theme="dark"] .app-portal-tooltip {
  background: #2d2d3a;
  color: #cdd6f4;
  border: 1px solid #585b70;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}
@media (prefers-reduced-motion: reduce) {
  .app-portal-tooltip { transition: none; }
}

/* SplitPane 스타일 커스터마이징 — 두께 축소 + 가운데 grip 으로 드래그 가능 명시. */
.Resizer.horizontal {
  height: 5px !important;
  background: #eee !important;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  cursor: ns-resize !important;
  margin: -1px 0;
  z-index: 5;
  position: relative;
}
.Resizer.horizontal::after {
  /* 가운데에 가로 점 3개 grip — 드래그 핸들임을 시각적으로 표시. */
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 3px;
  background: radial-gradient(circle, #999 1px, transparent 1.5px) 0 50%/8px 100% repeat-x;
  pointer-events: none;
}
.Resizer.horizontal:hover {
  background: #ddd !important;
}
.Resizer.horizontal:hover::after {
  background: radial-gradient(circle, #555 1.5px, transparent 2px) 0 50%/8px 100% repeat-x;
}
[data-theme="dark"] .Resizer.horizontal::after {
  background: radial-gradient(circle, #aaa 1px, transparent 1.5px) 0 50%/8px 100% repeat-x;
}
[data-theme="dark"] .Resizer.horizontal:hover::after {
  background: radial-gradient(circle, #fff 1.5px, transparent 2px) 0 50%/8px 100% repeat-x;
}

/* 영역 접기/펼치기 버튼 — 에디터 toolbar 에 배치. */
.split-collapse-btn {
  background: transparent;
  border: 1px solid var(--color-border, #d1d5db);
  border-radius: 3px;
  padding: 4px 5px;
  line-height: 1; /* 줄 상자를 글자 높이에 맞춰 레이블이 아래로 치우치지 않게 — 줄인 만큼 위아래 여백을 늘려 높이는 그대로 */
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: var(--color-text-secondary, #555);
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}
.split-collapse-btn:hover {
  background: var(--color-hover, #f3f4f6);
  color: var(--color-text, #1f2937);
  border-color: var(--color-border, #9ca3af);
}
.split-collapse-btn.active {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
  border-color: rgba(29, 78, 216, 0.5);
}
[data-theme="dark"] .split-collapse-btn {
  border-color: var(--color-border);
  color: var(--color-text-secondary);
}
[data-theme="dark"] .split-collapse-btn:hover {
  background: var(--color-hover);
  color: var(--color-text);
}
[data-theme="dark"] .split-collapse-btn.active {
  background: rgba(108, 182, 255, 0.18);
  color: #8fc7ff;
  border-color: rgba(108, 182, 255, 0.5);
}

/* SQLEditor와 ResultGrid를 감싸는 Pane 내부의 div 스타일 */
.sql-editor-pane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  min-height: 0;
  background: var(--color-bg);
}

.sql-editor-inner-container { /* SQLEditor.js 내부의 최상위 div.
   display:flex 가 반드시 있어야 한다. 자식(에디터+미니맵 래퍼)이 flex:1 로 높이를 받는데,
   이게 block 이면 flex 가 무시돼 자식이 "문서 전체 높이" 로 늘어난다.
   실측(60줄 문서): block 이면 래퍼 7,933px · 내부 스크롤 불가 · 커서가 클리핑 영역 밖
   (1197px)으로 나가 보이지 않았다. flex 를 주면 422px · 스크롤 정상 · 커서 보임.
   문서가 크면 미니맵 canvas 높이가 20만 px 를 넘어 브라우저 한계로 렌더도 깨졌다.
   ⚠️ 예전 주석은 이 증상("커서가 맨 아래에서 깜빡이고 타이핑이 안 보임")의 원인을
   display:flex 로 지목했으나 인과가 반대였다 — block 이 원인이다. 되돌리지 말 것. */
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  min-height: 0;
}

.codemirror-editor-area { /* SQLEditor.js 내부의 CodeMirror 편집기 영역 */
  flex-grow: 1;
  flex-shrink: 1; /* 필요시 수축 허용 */
  /* 높이는 SQLEditor.js 내부에서 flex-grow로 이미 설정되어 있음 */
  display: flex; /* 추가: 내부 cm-editor가 높이를 100% 차지하도록 */
  flex-direction: column; /* 추가 */
  min-height: 0; /* flex 컨테이너에서 수축 허용 */
  overflow: hidden; /* 자식 요소의 스크롤이 관리하도록 */
}

/* CodeMirror 전체 배경 및 높이 일관성 적용 */
.codemirror-editor-area .cm-editor {
  background-color: #ffffff; /* 밝은 배경색으로 변경 */
  height: 100% !important; /* 부모 높이를 완전히 채우도록 */
  color: #333333; /* 어두운 텍스트 색상으로 변경 */
  font-size: var(--font-size-mono);
  /* 자체 테두리를 그리지 않는다 — 에디터를 둘러싼 네 변에 이미 다른 선이 있어서
     (왼쪽 .schema-explorer-area 의 border-right, 위 .file-tabs-container 의
     border-bottom, 아래 .Resizer.horizontal 의 border-top) 여기서 또 그으면
     그 변만 2px 로 보인다. PL/SQL 모달처럼 테두리가 필요한 곳은 감싸는 wrap 이
     긋는다 (.plsqled-editor-wrap / .plsqled-testcall-editor-wrap). */
  flex-grow: 1; /* flex 컨테이너에서 남은 공간 차지 */
  flex-shrink: 1; /* 필요시 수축 허용 */
  min-height: 200px; /* 최소 높이 보장 */
}

.codemirror-editor-area .cm-scroller {
  /* 스크롤 영역 자체에는 별도 배경색을 지정하지 않아 cm-editor 배경색이 보이도록 함 */
  overflow: auto !important; /* 세로 스크롤바 강제 표시 */
  height: 100% !important;
  max-height: 100% !important; /* 최대 높이 제한 */
}

/* CodeMirror content 영역 padding 조정을 제거하여 CodeMirror 네이티브 가상 스크롤 및 좌표 계산이 정상 작동하게 함 */
/* CodeMirror 밝은 테마 추가 스타일 */
.codemirror-editor-area .cm-editor.cm-focused {
  /* 포커스 테두리를 그리지 않는다 — 메인 화면의 다른 영역(결과 그리드·탐색기)은
     클릭해도 테두리가 바뀌지 않으므로 에디터만 파란 테두리를 그리면 어긋난다.
     CodeMirror 기본 outline 도 여기서 함께 지운다. */
  outline: none;
}

.codemirror-editor-area .cm-activeLine {
  background-color: #f8f9fa; /* 활성 라인 배경색 */
}

.codemirror-editor-area .cm-activeLineGutter {
  background-color: #e9ecef; /* 활성 라인 거터 배경색 */
}

.sql-editor-buttons {
  flex-shrink: 0; /* 버튼 영역은 줄어들지 않음 */
  padding-top: 10px;
}

.result-and-pagination-area {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  background: var(--color-bg);
}

/* MainDisplayTabs가 이 영역 내에서 남은 공간을 차지하도록 App.js에서 MainDisplayTabs를 감싸는 div에 flex-grow:1을 주거나, MainDisplayTabs 컴포넌트 자체의 최상위 div에 스타일을 적용해야 할 수 있음. */
/* 여기서는 result-and-pagination-area를 flex container로 만들고, MainDisplayTabs와 StatusLine이 그 자식으로 배치됨. */
/* MainDisplayTabs 컴포넌트의 최상위 div가 .mainDisplayTabsContainer 이므로, 여기에 flex-grow:1 을 주면 됨. */

/* Result Grid Styles for Sticky Header */
.result-grid {
  flex: 1 1;
  min-height: 0;
  min-width: 0;          /* flex 자식의 기본 min-width:auto(=min-content) 해제 — 안 그러면 가로 콘텐츠가 부모를 뚫고 나가 overflow:auto 가 무력화됨 → 가로 스크롤바 안 뜸. */
  max-height: 100%;
  overflow: auto;
  /* 테두리 대신 **배경색**으로 경계를 보인다(2026-10-07) — 표 밖(마지막 열 오른쪽·마지막 행 아래)은 옅은 회색, 셀은 흰색.
     테두리를 두면 탭 머리줄의 아래선과 겹쳐 2px 로 보였고, 표 바깥쪽 선은 표의 border-style:hidden 에 가려 셀 아래·오른쪽이 비어 보였다. */
  border: none;
  background: var(--rg-outside-bg, #f0f2f5);
  position: relative;
  margin-bottom: 10px; /* 페이지네이션과의 간격 */
  /* 스크롤바 항상 표시 — Windows 11 / 최신 Chrome 의 overlay (auto-hide) 스크롤바 동작을
     명시적 webkit 스타일링으로 override. firefox 도 scrollbar-color 로 가시성 보장. */
  scrollbar-color: #888 #f0f0f0;
  scrollbar-width: auto;
}
.result-grid::-webkit-scrollbar {
  width: 14px;
  height: 14px;
  background: #f0f0f0;
}
.result-grid::-webkit-scrollbar-track {
  background: #f0f0f0;
}
.result-grid::-webkit-scrollbar-thumb {
  background: #888;
  border: 3px solid #f0f0f0;
  border-radius: 7px;
}
.result-grid::-webkit-scrollbar-thumb:hover {
  background: #666;
}
.result-grid::-webkit-scrollbar-corner {
  background: #f0f0f0;
}
[data-theme="dark"] .result-grid {
  scrollbar-color: #666 #1e1e1e;
}
[data-theme="dark"] .result-grid::-webkit-scrollbar,
[data-theme="dark"] .result-grid::-webkit-scrollbar-track,
[data-theme="dark"] .result-grid::-webkit-scrollbar-corner {
  background: #1e1e1e;
}
[data-theme="dark"] .result-grid::-webkit-scrollbar-thumb {
  background: #555;
  border-color: #1e1e1e;
}
[data-theme="dark"] .result-grid::-webkit-scrollbar-thumb:hover {
  background: #777;
}

.result-grid table {
  /* width: 0 → 컬럼은 명시 cell width 그대로, redistribution 없음 (사용자 검증 OK).
     테이블의 outer 측정 width 는 0 이지만 wrapper(.result-grid-table-wrap)가 JS 계산 polygonal 합계를
     style.minWidth 로 강제 → 부모 overflow 검출에 사용됨. */
  width: 0;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: var(--font-size-grid);
  border-style: hidden;
}
/* table 을 감싸는 wrapper — JS 가 컬럼 합계를 minWidth 로 인라인 적용.
   - block-level wrapper. CSS 로 width 강제 X. JSX 의 style.minWidth 가 단독 sizing source.
   - 부모(.result-grid) 는 wrapper 의 minWidth 를 보고 overflow 감지 → 가로 스크롤바 표시.
   - CSS 의 max-content 같은 intrinsic sizing 에 의존하지 않으므로 Chrome quirks 영향 X. */
.result-grid-table-wrap {
  display: inline-block;     /* 자식(table) 의 시각 폭으로 sizing + 부모 폭 stretch 거부 */
  vertical-align: top;       /* inline-level baseline 빈 공간 제거 */
  /* 인라인 style.minWidth 가 JS 가 계산한 컬럼 합계를 강제 → 부모 overflow:auto 가 정확히 검출 */

  /* 가로 스크롤바 자리를 비워 둔다. 스크롤바는 스크롤 영역 **안쪽** 아래를 차지하므로,
     내용 높이가 딱 맞으면 **마지막 행이 스크롤바에 가려** 끝까지 내려도 보이지 않는다.
     가로로 넘치는 결과(예: dbms_xplan 출력)에서만 나타나서 "일반 조회는 안 가리는데
     이것만 가린다" 로 보였다(신고 2026-09-18). 스크롤바 높이(14px)만큼 여유를 준다. */
  padding-bottom: 14px;
}

.result-grid th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--color-grid-header);
  color: var(--color-text);
  font-weight: 600;
  /* 휠 확대/축소를 따른다(2026-10-07) — UI 고정 크기이던 때는 본문만 커지고 머리글은 그대로였다 */
  font-size: calc(var(--font-size-grid, 12px) - 1px);
  font-family: var(--font-ui);
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid var(--color-grid-border);
  padding: 4px 10px;       /* 세로 padding 축소 — 더 컴팩트한 헤더 */
  text-align: left; /* 왼쪽 정렬 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-grid td {
  /* 선은 옅게 — 세로선은 가로선보다 더(2026-10-07, 「라인은 슬림하게」). 값이 먼저 보여야 한다 */
  border: 1px solid #eceef1;
  border-left-color: #f3f4f6;
  border-right-color: #f3f4f6;
  padding: 3px 10px;       /* 세로 padding 축소 — 더 많은 행 표시 (이전 10px → 3px) */
  text-align: left; /* 왼쪽 정렬 */
  /* \`pre\` — 연속 공백을 **보존**한다. \`nowrap\` 은 줄바꿈만 막고 공백은 HTML 규칙대로 접어서,
     \`dbms_xplan.display_cursor\` 같은 자리 맞춤 출력의 들여쓰기가 통째로 사라졌다(실측 2026-09-18).
     평범한 값에는 \`nowrap\` 과 차이가 없다. */
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 결과 영역 위 도구줄(기본·수직 분할·창 분리 세 곳 공통).
   폭이 모자라면 **항목째 다음 줄로** 넘긴다 — 줄바꿈 없이 두면 체크박스 라벨이 줄어들며 한글이 한 글자씩
   세로로 꺾였다(「실/행/계/획/보/기」, 신고 2026-10-06). 라벨·버튼은 그 자체로는 꺾이지 않는다. */
.result-toolbar {
  display: flex;
  flex-wrap: wrap;
  /* 왼쪽부터 채운다 — 오른쪽 정렬로 두면 넘친 줄이 왼쪽 끝에서 잘린다. 넓을 때 나머지가 오른쪽에 붙는 것은
     첫 묶음(탭 필터)의 margin-right: auto 가 한다 */
  justify-content: flex-start;
  align-items: center;
  gap: 4px 8px;
  padding: 4px 6px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--color-border, #e0e0e0);
}
.result-toolbar > div { flex-wrap: wrap; }
.result-toolbar .compact-view-toggle,
.result-toolbar .detach-inline-btn { white-space: nowrap; flex-shrink: 0; }

/* 결과탭 툴바의 "압축 보기" 토글 — light/dark theme 대응. */
.compact-view-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: var(--color-text, #1f2937);
}
.compact-view-toggle input[type="checkbox"] {
  margin: 0;
  accent-color: #3b82f6;
}
[data-theme="dark"] .compact-view-toggle {
  color: var(--color-text);
}
[data-theme="dark"] .compact-view-toggle input[type="checkbox"] {
  color-scheme: dark;
  accent-color: #6cb6ff;
}

/* 체크박스 레이블 마우스 올림 — 체크박스만이 아니라 **아이콘·레이블까지 한 덩어리로** 강조한다(사용자 요청 2026-10-05).
   체크박스가 여럿 늘어서면 체크박스만 바뀌어서는 어느 레이블의 것인지 헷갈린다. 편집기 쪽(.editor-option-label)과
   결과 쪽(.compact-view-toggle)이 같은 모양이다. 강조색은 툴바 버튼(.detach-inline-btn:hover)과 같다. */
.editor-option-label,
.compact-view-toggle {
  padding: 1px 4px;
  border-radius: 3px;
  transition: color 150ms ease, background-color 150ms ease;
}
.editor-option-label:hover,
.compact-view-toggle:hover {
  color: #007bff;
  background-color: rgba(0, 123, 255, 0.08);
}
[data-theme="dark"] .editor-option-label:hover,
[data-theme="dark"] .compact-view-toggle:hover {
  color: #6cb6ff !important;   /* 다크의 기본 글자색이 !important 라 같이 준다 */
  background-color: var(--color-hover);
}
@media (prefers-reduced-motion: reduce) {
  .editor-option-label,
  .compact-view-toggle { transition: none; }
}

/* 그리드 셀 — 항상 cursor: pointer (잘려있으면 클릭 시 popup, 아니면 무동작). 링크 스타일은 적용하지 않음. */
.result-grid-cell {
  cursor: pointer;
}

/* NULL 셀 — 실제 빈 문자열과 구분되도록 흐린 이탤릭. 표시 텍스트는 설정에서 변경 가능. */
.result-grid-cell.is-null {
  color: var(--color-text-muted, #9ca3af);
  font-style: italic;
}

/* 잘린 셀 표시 — 우측 끝에 큰 ⋯ 오버레이. 클릭 자체는 셀(span) 의 onClick 이 받음 (pointer-events: none). */
.result-grid td.truncated {
  position: relative;
  text-overflow: clip; /* 브라우저 기본 작은 "..." 숨김 — 아래 ::after 가 대체 */
}
/* 잘림 표시는 **눈에 띄지 않아야** 한다 — 값이 아니라 값이 더 있다는 귀띔이다.
   예전에는 18px·굵기 800·파란색이라 데이터보다 강해서, 화면이 파란 점으로 얼룩져 보였다. */
.result-grid td.truncated::after {
  content: '…';
  position: absolute;
  right: 1px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: var(--color-text-muted, #9ca3af);
  background: linear-gradient(to right, transparent 0, var(--color-bg, #fff) 6px);
  padding-left: 6px;
  pointer-events: none;
}
[data-theme="dark"] .result-grid td.truncated::after {
  color: var(--color-text-muted);
  background: linear-gradient(to right, transparent 0, var(--color-bg) 6px);
}
/* 압축 모드에선 살짝 작게 */
.result-grid-compact td.truncated::after {
  font-size: 11px;
  width: 12px;
}

/* Recharts Tooltip 다크모드 강제 오버라이드 (인라인 스타일 무시 방지) */
[data-theme="dark"] .recharts-default-tooltip {
  background-color: #1f2937 !important;
  border-color: #4b5563 !important;
}


/* 압축 보기 — 셀 여백/줄높이/폰트 모두 최소화. 한 화면에 더 많은 행/열 표시. */
.result-grid-compact th,
.result-grid-compact td {
  padding: 1px 4px;
  line-height: 1.15;
  min-width: 40px;
  font-size: calc(var(--font-size-grid, 13px) - 1px);
}
.result-grid-compact td:first-child div {
  padding: 1px 2px;
}
.result-grid-compact .column-header-content {
  padding: 0;
}
/* 헤더의 컬럼 코멘트 부제 (작은 회색 글자) 도 압축 모드에선 한 줄로 더 작게. */
.result-grid-compact th span span {
  font-size: 9px !important;
  margin-top: 0 !important;
  line-height: 1.1 !important;
}

.loading-more-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    padding: 15px;
    color: #666;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    font-size: var(--font-size-ui);
}

.loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #e9ecef;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; 
  gap: 10px;
}

.side-panel-area {
  /* 줄어들 수 있게 둔다(flex-shrink 1). 못 줄면 창이 좁을 때(125% 배율 등) 이 900px 과 AI 에이전트
     520px 이 넘쳐, **맨 오른쪽의 AI 에이전트가 화면 밖으로 잘렸다.** 안쪽은 폭이 고정이라
     좁아지면 이 패널의 오른쪽이 잘릴 뿐 글자가 다시 배치되지 않는다. */
  /* 실행이력만 여기 남았다(2026-10-19) — 폭은 예전(900px)의 절반. 편집기를 분리했을 때 오는 실행계획 분석·챌린지는 .wide 로 예전 폭 */
  flex: 0 1 450px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #ccc;
  /* 스르르 접히고 펼쳐진다. 예전에는 이 규칙이 있어도 소용없었다 — 패널을 조건부로 렌더해
     DOM 에서 통째로 사라졌기 때문이다. 이제 늘 그려 두고 폭만 바꾼다. */
  transition: flex-basis 260ms ease, padding 260ms ease, opacity 200ms ease;
  overflow: hidden;
  padding: 10px;
  background-color: #f9f9f9;
  position: relative;
  z-index: 20;
}

.side-panel-area.wide { flex-basis: 900px; }
/* 데이터 분석도 같은 틀 — 패널 자체의 폭(420)·왼쪽 선을 풀어 실행이력과 같은 폭으로 채운다 */
.side-panel-area.wide .side-panel-inner { min-width: 880px; }

.side-panel-area.closed {
  flex-basis: 0;
  padding: 0;
  border-left: none;
  opacity: 0;
  pointer-events: none;
}

/* 안쪽은 **폭이 고정**이다. 접힐 때 내용까지 좁아지면 글자가 다시 배치되며 출렁인다 —
   바깥이 좁아지고 안쪽은 그대로 잘려 나가야 미닫이처럼 보인다. (900 - 좌우 padding 20) */
.side-panel-inner {
  /* 열려 있을 때는 **딱 맞게**(100%), 접히는 동안만 줄지 않는다(min-width).
     예전에는 880px 로 못 박아서 열린 폭과 어긋나 오른쪽이 살짝 넘쳤다. */
  width: 100%;
  min-width: 430px;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

@media (prefers-reduced-motion: reduce) {
  .side-panel-area { transition: none; }
}

.sql-history {
  flex-grow: 1;
  display: flex;
  flex-direction: column; 
}

.App {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 10px;
  font-family: 'Arial', sans-serif;
  border: 1px solid #ccc;
}

.username-input, .owner-select {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
}

.username-label, .owner-select-label {
  font-weight: bold;
  margin-right: 0;
}

.clear-history-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.clear-history-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 10px;
  cursor: pointer;
  border-radius: 5px;
}

/* 헤더 영역 스타일 */
/* 제목을 뺀 뒤로는 전체 삭제 버튼만 담는 줄이다. 버튼이 없으면 자리도 차지하지 않는다. */
.history-header-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 0;
}
.history-header-section:not(:empty) { margin-bottom: 6px; }

.history-header-section .section-title {
  margin: 0;
  flex-grow: 1;
}

/* 헤더의 전체 삭제 버튼 */
.clear-history-button-header {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 6px 12px;
  font-size: 11px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clear-history-button-header:hover {
  background-color: #da190b;
}

/* 개별 삭제 버튼 */
.delete-history-item-button {
  background-color: #dc3545;
  color: white;
  border: none;
  width: 20px;
  height: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  line-height: 1;
}

.delete-history-item-button:hover {
  background-color: #c82333;
}

.history-list {
  flex: 1 1 auto;
  overflow-y: auto;
  margin-bottom: 40px;
}

/* 새로운 히스토리 테이블 스타일 */
.history-table {
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.history-header {
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 2px solid #ddd;
  font-weight: bold;
  font-size: 12px;
  color: #495057;
  /* 스크롤바 너비만큼 여백 추가 */
  padding-right: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.history-header > div {
  padding: 8px 6px;
  border-right: 1px solid #ddd;
  text-align: center;
}

.history-header > div:last-child {
  border-right: none;
}

.history-body {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.history-row {
  display: flex;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.history-row:hover {
  background-color: #f8f9fa;
}

.history-row.success {
  box-shadow: inset 3px 0 0 #28a745;
}

.history-row.error {
  box-shadow: inset 3px 0 0 #dc3545;
}

.history-row > div {
  padding: 6px 6px;
  border-right: 1px solid #eee;
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-row > div:last-child {
  border-right: none;
}

/* 컬럼 너비 설정 */
.history-col-datetime {
  flex: 0 0 120px;
  min-width: 120px;
}

.history-col-status {
  flex: 0 0 50px;
  min-width: 50px;
  text-align: center;
}

.history-col-query {
  flex: 1 1;
  min-width: 200px;
  text-align: left;
}

.history-col-count {
  flex: 0 0 80px;
  min-width: 80px;
  text-align: right;
}

.history-col-time {
  flex: 0 0 70px;
  min-width: 70px;
  text-align: right;
}

.history-col-delete {
  flex: 0 0 50px;
  min-width: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: center;
}

/* 상태 배지 */
.status-badge {
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
}

.status-badge.success {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.error {
  background-color: #f8d7da;
  color: #721c24;
}

/* 더보기 표시 */
.more-indicator {
  color: #007bff;
  font-size: 10px;
  font-style: italic;
}

.error-text {
  color: #6c757d;
  font-style: italic;
}

/* 히스토리 없음 메시지 */
.no-history {
  text-align: center;
  color: #6c757d;
  font-style: italic;
  padding: 32px 16px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  background-color: #f8f9fa;
  /* 조상이 어떤 폭이든 **넘치지 않는다.** padding·border 를 폭 안에 넣고(border-box)
     좌우 여백을 줘 패널 가장자리에 딱 붙지 않게 한다 — 붙으면 넘친 것처럼 보인다. */
  box-sizing: border-box;
  max-width: 100%;
  margin: 4px 8px;
}

/* 패널 안의 절 제목 — **한 가지 모양만** 쓴다.
   예전에는 같은 클래스가 자리마다 다르게 보였다: 이력에서는 1.2em 밑줄 제목,
   튜닝의 헤더 막대 안에서는 13px 인데 밑줄이 또 그어져 이중선이 됐다.
   밑줄이 필요한 곳은 감싸는 쪽이 긋는다(.history-header-section). */
.section-title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-ui, 12px);
  font-weight: 600;
  color: var(--color-text-secondary, #4b5563);
}

.no-results {
  color: #999;
  text-align: center;
  padding: 20px;
}

.error-message {
  color: red;
  font-weight: bold;
}

.column-header-content {
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 8px; /* 리사이저 공간 확보 */
}

.result-grid th .column-resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
  border-right: 2px solid transparent;
  z-index: 15; /* sticky header보다 높게 설정 */
  -webkit-user-select: none;
          user-select: none;
}

.result-grid th .column-resizer:hover {
  border-right-color: #007bff;
  background-color: rgba(0, 123, 255, 0.1);
}

.result-grid th .column-resizer:active {
  border-right-color: #0056b3;
  background-color: rgba(0, 123, 255, 0.2);
}

/* 리사이즈 중 오버레이 */
.resize-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: col-resize;
  z-index: 9999;
  background: transparent;
}

/* 행 번호 컬럼 (첫 번째) — 헤더 # 와 동일하게 본문 숫자값도 왼쪽 정렬. */
.result-grid td[data-type="__system__"],
.result-grid td[data-type="__system__"] > * {
  text-align: left;
}

/* 데이터 타입별 스타일 — **정렬만** 다르게 한다. 글꼴·굵기·색은 모든 데이터 셀이 같다(사용자 요청 2026-09-13).
   예전엔 숫자·날짜·id 에 가는 'Courier New', 이름에 "id" 가 든 컬럼에 회색(#666, 다크모드에서도 이겼다),
   참/거짓에 굵게를 줘서 같은 행 안에서 값마다 진하게/흐리게 보였다.
   자료형 추정(ResultGrid.detectDataType)은 표본 10행으로 하는 짐작이라 모양까지 바꾸면 틀릴 때 더 눈에 띈다.
   NULL(흐린 이탤릭)과 행 번호 열(__system__)은 "값 없음"·"데이터 아님" 표시라 따로 둔다. */
.result-grid td[data-type="number"] {
  text-align: right;
  font-variant-numeric: tabular-nums; /* 같은 글꼴에서 자릿수 폭만 맞춘다 — 굵기·색은 그대로 */
}

.result-grid td[data-type="boolean"] {
  text-align: center;
}

/* 로우 순번 컬럼 전용 스타일 */
.result-grid th:first-child,
.result-grid td:first-child {
  position: sticky;
  left: 0; /* 좌우 스크롤에 고정 */
  background-color: #fafafa !important;
  min-width: var(--rg-rownum-w, 30px) !important;
  max-width: var(--rg-rownum-w, 30px) !important;
  width: var(--rg-rownum-w, 30px) !important;
  text-align: center;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
}

/* 로우 순번 헤더 - 상하/좌우 스크롤 모두에 고정 */
.result-grid th:first-child {
  top: 0;
  z-index: 25;
  background-color: #f0f0f0 !important;
  color: #666;
  font-size: calc(var(--font-size-grid, 12px) - 1px);
  padding: 4px 2px !important;
  text-align: center !important;
}
/* 「#」 가운데 — 머리글 내용 칸은 리사이저 자리(오른쪽 8px)를 비우는 flex 라 왼쪽으로 치우쳐 있었다 */
.result-grid th:first-child .column-header-content {
  justify-content: center;
  padding-right: 0;
}

.result-grid th:first-child span {
  display: block;
  width: 100%;
  text-align: center;
}

/* 로우 순번 데이터 셀 */
.result-grid td:first-child {
  z-index: 20; /* 일반 셀보다 높게 설정 */
  color: #999;
  font-size: calc(var(--font-size-grid, 12px) - 1px);
  padding: 0 !important;
}

/* 세로 padding 은 데이터 셀과 같게 — 8px 이던 시절에는 순번 칸이 행 높이를 정해서(약 31px)
   「압축」을 켜도 행이 그대로였다(신고 2026-10-01). */
.result-grid td:first-child div {
  padding: 3px 2px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 로우 순번 컬럼의 resizer는 숨김 */
.result-grid th:first-child .column-resizer {
  display: none !important;
}

/* SQL History - 선택된 행 스타일 */
.history-row.selected {
  background-color: #e3f2fd !important;
  border-left: 3px solid #2196f3 !important;
}

/* 선택된 쿼리 상세 표시 섹션 */
.selected-query-section {
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fafafa;
}

.selected-query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.selected-query-header h3 {
  margin: 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.close-query-button {
  background: none;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.close-query-button:hover {
  background-color: #f0f0f0;
  color: #666;
}

/* 쿼리 메타 정보 */
.selected-query-info {
  margin-bottom: 10px;
}

.query-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  font-size: 12px;
}

.query-time {
  color: #666;
  font-weight: 500;
}

.query-status.success {
  color: #28a745;
  font-weight: 600;
}

.query-status.error {
  color: #dc3545;
  font-weight: 600;
}

.query-count {
  color: #17a2b8;
  font-weight: 500;
}

.query-exec-time {
  color: #6c757d;
  font-style: italic;
}

.query-error {
  margin-top: 8px;
  padding: 8px 10px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 3px;
  color: #721c24;
  font-size: 12px;
}

.query-error strong {
  font-weight: 600;
}

/* SQL 쿼리 텍스트 표시 영역 */
.selected-query-content {
  margin: 10px 0;
}

.sql-query-text {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  margin: 0;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #333;
  max-height: 200px;
  overflow-y: auto;
}

/* 액션 버튼 영역 */
.selected-query-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #eee;
}

.copy-to-editor-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.copy-to-editor-button:hover {
  background-color: #0056b3;
}

/* 바인드 변수 관련 스타일 */
.bind-variables-indicator {
  color: #6f42c1;
  font-weight: 500;
  font-size: 11px;
}

.bind-variables-info {
  margin-top: 8px;
  padding: 8px 10px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 3px;
  font-size: 12px;
}

.bind-variables-info strong {
  color: #495057;
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}

.bind-variables-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bind-variable-item {
  background-color: #e9ecef;
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 11px;
  color: #495057;
}

.bind-variable-item code {
  background-color: transparent;
  color: inherit;
  font-size: inherit;
}

/* 쿼리 섹션 구분 */
.query-section {
  margin-bottom: 15px;
}

.query-section:last-child {
  margin-bottom: 0;
}

.query-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
  padding: 3px 0;
  border-bottom: 1px solid #dee2e6;
}

.sql-query-text.original {
  border-left: 3px solid #6f42c1;
  background-color: #faf9ff;
}

.sql-query-text.executed {
  border-left: 3px solid #17a2b8;
  background-color: #f8fdff;
}

/* Row Number Grid Styles */
.result-grid td[data-type="__system__"] {
  background-color: #f8f9fa;
  color: #6c757d;
  font-weight: 500;
  text-align: center;
}

[data-theme="dark"] .result-grid td[data-type="__system__"] {
  background-color: var(--color-bg-secondary);
  color: var(--color-text-secondary);
  border-color: var(--color-border);
}
[data-theme="dark"] .result-grid th:first-child,
[data-theme="dark"] .result-grid td:first-child {
  background-color: var(--color-bg-secondary) !important;
  color: var(--color-text-muted) !important;
  border-color: var(--color-grid-border) !important;
}
[data-theme="dark"] .result-grid th:first-child {
  background-color: var(--color-bg-tertiary) !important;
}

/* SQL 실행이력 다크모드 */
[data-theme="dark"] .sql-history { color: var(--color-text); }
[data-theme="dark"] .history-header { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; border-bottom: 2px solid var(--color-border) !important; }
[data-theme="dark"] .history-header > div { border-color: var(--color-border) !important; color: var(--color-text-muted) !important; }
[data-theme="dark"] .status-badge.success { background: rgba(46,125,50,0.2) !important; color: #4caf50 !important; }
[data-theme="dark"] .status-badge.error { background: rgba(198,40,40,0.2) !important; color: #ef5350 !important; }
[data-theme="dark"] .history-body { color: var(--color-text); }
[data-theme="dark"] .history-row { border-color: var(--color-border); }
[data-theme="dark"] .history-row:hover { background: var(--color-hover); }
[data-theme="dark"] .history-row.selected { background-color: rgba(59, 130, 246, 0.15) !important; border-left-color: #3b82f6 !important; }
[data-theme="dark"] .history-row > div { border-color: var(--color-border); color: var(--color-text-secondary); }
[data-theme="dark"] .history-row > .history-col-query { color: var(--color-text); }
[data-theme="dark"] .more-indicator { color: #60a5fa; }
[data-theme="dark"] .history-row.success { box-shadow: inset 3px 0 0 #2e7d32; }
[data-theme="dark"] .history-row.error { box-shadow: inset 3px 0 0 #c62828; }
[data-theme="dark"] .history-row.success .history-col-status { color: #4caf50; }
[data-theme="dark"] .history-row.error .history-col-status { color: #ef5350; }
[data-theme="dark"] .history-header-section { color: var(--color-text); border-color: var(--color-border); }
/* 밑줄은 이제 감싸는 쪽(.history-header-section)이 긋는다 — 아래 규칙이 그것을 바꾼다 */
[data-theme="dark"] .history-header-section .section-title { color: var(--color-text-secondary); }
[data-theme="dark"] .delete-history-item-button { background: #555; color: var(--color-text-muted); }
[data-theme="dark"] .delete-history-item-button:hover { background: #c62828; color: #fff; }
/* 글자색만 바꾸면 배경(#f8f9fa)과 점선 테두리(#ddd)가 밝은 값 그대로 남아
   어두운 화면에 흰 상자가 뜬다 — 세 가지를 함께 바꾼다. */
[data-theme="dark"] .no-history {
  color: var(--color-text-muted);
  background-color: var(--color-bg-secondary);
  border-color: var(--color-border);
}

/* 같은 화면(이력 패널)의 바인드 변수 안내 — 다크 규칙이 아예 없어 밝은 상자로 남아 있었다 */
/* 결과 그리드의 로딩 링 — 밝은 회색(#e9ecef) 궤도가 어두운 배경에서 도드라진다 */
[data-theme="dark"] .loading-spinner { border-color: var(--color-border); border-top-color: var(--color-accent-fg); }
[data-theme="dark"] .bind-variables-info {
  background-color: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}
[data-theme="dark"] .bind-variables-info strong { color: var(--color-text-secondary); }
[data-theme="dark"] .bind-variable-item {
  background-color: var(--color-bg-tertiary);
  color: var(--color-text);
}
[data-theme="dark"] .selected-query-section { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .selected-query-header { border-bottom-color: var(--color-border); }
[data-theme="dark"] .selected-query-header h3 { color: var(--color-text); }
[data-theme="dark"] .close-query-button { color: var(--color-text-muted); }
[data-theme="dark"] .close-query-button:hover { background-color: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .query-time { color: var(--color-text-secondary); }
[data-theme="dark"] .query-exec-time { color: var(--color-text-muted); }
[data-theme="dark"] .query-error { background-color: rgba(220, 53, 69, 0.1); border-color: rgba(220, 53, 69, 0.3); color: #ff6b6b; }
[data-theme="dark"] .selected-query-actions { border-top-color: var(--color-border); }
[data-theme="dark"] .query-section-title { color: var(--color-text-secondary); border-color: var(--color-border); }
[data-theme="dark"] .sql-query-text { background: var(--color-bg); border-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .sql-query-text.original { background: rgba(111,66,193,0.1); border-left-color: #9b59b6; }
[data-theme="dark"] .sql-query-text.executed { background: rgba(23,162,184,0.1); border-left-color: #17a2b8; }
[data-theme="dark"] .copy-to-editor-button { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-border); }
[data-theme="dark"] .copy-to-editor-button:hover { background: var(--color-hover); }
[data-theme="dark"] .clear-history-button-header { background: #c62828; }
[data-theme="dark"] .delete-history-button { color: var(--color-text-muted); }
[data-theme="dark"] .delete-history-button:hover { color: #ff6b6b; }
/* 쿼리 챌린지 다크모드 — CSS 변수가 이미 적용된 컴포넌트 */
[data-theme="dark"] .challenge-dark-wrapper * {
  box-shadow: none !important;
  text-shadow: none !important;
}

.challenge-dark-wrapper {
  font-size: 12px;
  /* 부모(.history-challenge-tabs-content)는 flex column 인데 이 래퍼가 \`flex: 0 1 auto\` 라
     **내용 높이만큼만** 차지했다 — 그래서 챌린지 화면 아래가 늘 비어 있었다(지적 2026-09-19).
     안쪽은 이미 남는 높이를 나눠 갖게 돼 있으니, 여기서 높이를 열어 주면 지문도 같이 커진다. */
  flex: 1 1;
  min-height: 0;
}

[data-theme="dark"] .history-table { border-color: var(--color-border) !important; }
[data-theme="dark"] .history-list { border-color: var(--color-border) !important; }
[data-theme="dark"] .history-header-section { border-color: var(--color-border) !important; }

/* 챌린지 파일 주고받기 버튼 — 툴바의 새로고침과 같은 높이·모양 */
.challenge-file-btn {
  height: 28px;
  padding: 0 10px;
  /* 글자가 두 줄로 꺾여 버튼이 찌그러지던 것 (신고 2026-09-19) */
  white-space: nowrap;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
  background: var(--color-bg, #fff);
  color: var(--color-text, #333);
  border: 1px solid var(--color-border, #ddd);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.challenge-file-btn:hover { background: var(--color-hover, #f3f4f6); border-color: var(--color-accent, #3b82f6); }
@media (prefers-reduced-motion: reduce) { .challenge-file-btn { transition: none; } }

/* 챌린지 문제 출처 선택 — 툴바 버튼과 같은 높이 */
.challenge-source-select {
  height: 28px;
  padding: 0 6px;
  max-width: 140px;
  flex-shrink: 0;
  font-size: 11px;
  background: var(--color-bg, #fff);
  color: var(--color-text, #333);
  border: 1px solid var(--color-border, #ddd);
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 150ms ease;
}
.challenge-source-select:hover { border-color: var(--color-accent, #3b82f6); }
@media (prefers-reduced-motion: reduce) { .challenge-source-select { transition: none; } }

/* 챌린지 상단 도구 줄 — 좁아지면 **줄바꿈**하되 버튼 자체는 찌그러지지 않는다.
   예전에는 한 줄에 밀어 넣어 「내보 내기」처럼 글자가 꺾였다. */
.challenge-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* ── 결과 표 — 열 고정 · 행 고정 (2026-10-01, utils/gridPin.js) ──
   고정 열은 순번 칸(left:0, 30px) 뒤에 sticky 로 선다. 배경이 없으면 밑으로 지나가는 셀이 비친다. */
.result-grid td.rg-pin-col,
.result-grid th.rg-pin-col {
  position: sticky;
  background-color: var(--color-bg, #fff);
}
.result-grid td.rg-pin-col { z-index: 5; }
.result-grid th.rg-pin-col { z-index: 22; background-color: var(--color-grid-header); }
.result-grid .rg-pin-col-last { box-shadow: inset -2px 0 0 rgba(59, 130, 246, 0.55); }
/* 고정 행 — 머리글 아래(top 은 인라인). 순번·고정 열과 겹치는 칸은 더 위에 */
.result-grid tr.rg-pinned-row td {
  position: sticky;
  z-index: 8;
  background-color: #fffbeb;
}
.result-grid tr.rg-pinned-row td.rg-pin-col { z-index: 21; }
.result-grid tr.rg-pinned-row td:first-child { z-index: 24; color: #b45309 !important; background-color: #fef3c7 !important; }
.result-grid tr.rg-pinned-row-last td { box-shadow: inset 0 -2px 0 rgba(217, 119, 6, 0.5); }
/* 본문에서 고정된 행 — 순번만 표시(어디 있던 행인지 잃지 않게) */
.result-grid tr.rg-row-pinned td:first-child { color: #b45309 !important; font-weight: 700; }
[data-theme="dark"] .result-grid td.rg-pin-col { background-color: var(--color-bg); }
[data-theme="dark"] .result-grid tr.rg-pinned-row td { background-color: #3a2f12; }
[data-theme="dark"] .result-grid tr.rg-pinned-row td:first-child { background-color: #4a3b12 !important; color: #fbbf24 !important; }
[data-theme="dark"] .result-grid tr.rg-row-pinned td:first-child { color: #fbbf24 !important; }

/* 머리글 우클릭 메뉴 */
.rg-header-menu {
  position: fixed;
  z-index: 1000;
  min-width: 170px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  animation: rg-header-menu-in 140ms ease-out;
}
.rg-header-menu button {
  text-align: left;
  padding: 6px 10px;
  border: none;
  background: none;
  border-radius: 4px;
  font-size: 12.5px;
  color: #1f2937;
  cursor: pointer;
  transition: background-color 150ms ease;
}
.rg-header-menu button:hover:not(:disabled) { background: #f3f4f6; }
.rg-header-menu button:disabled { color: #9ca3af; cursor: default; }
[data-theme="dark"] .rg-header-menu { background: var(--color-bg-tertiary, #252526); border-color: var(--color-border, #3a3a3a); }
[data-theme="dark"] .rg-header-menu button { color: var(--color-text, #ddd); }
[data-theme="dark"] .rg-header-menu button:hover:not(:disabled) { background: var(--color-hover, #2a2d2e); }
[data-theme="dark"] .rg-header-menu button:disabled { color: var(--color-text-muted, #777); }
@keyframes rg-header-menu-in {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .rg-header-menu { animation: none; }
  .rg-header-menu button { transition: none; }
}

/* 트랜잭션 칩 — 미커밋 변경이 있을 때만(components/EditorToolbarRight.js TxnChip) */
.txn-chip { padding: 1px 4px 1px 8px; border-radius: 6px; background: #fffbeb; border: 1px solid #fcd34d; animation: txn-chip-fade 160ms ease-out; }
.txn-chip-label { display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #92400e; margin-right: 2px; }
.txn-chip .txn-commit { color: #166534; }
.txn-chip .txn-rollback { color: #b91c1c; }
@keyframes txn-chip-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
[data-theme="dark"] .txn-chip { background: rgba(146, 64, 14, 0.25); border-color: #92400e; }
[data-theme="dark"] .txn-chip-label { color: #fde68a; }
[data-theme="dark"] .txn-chip .txn-commit { color: #86efac; }
[data-theme="dark"] .txn-chip .txn-rollback { color: #fca5a5; }
@media (prefers-reduced-motion: reduce) { .txn-chip { animation: none; } }

/* ── 결과 표 — 5행 띠 · 셀 범위 선택 (2026-10-07) ──
   띠는 아주 옅게: 줄을 따라 읽을 때 눈이 미끄러지지 않을 만큼만. 선택은 utils/gridCopy.js(Ctrl+C = 탭 구분 복사) */
/* 셀은 불투명한 색 — 표 밖 배경(회색)이 비치지 않게. 띠는 그 위에 아주 옅은 차이 */
.result-grid tbody td { background-color: var(--color-bg, #fff); }
.result-grid tr.rg-band td { background-color: #f8f9fb; }
[data-theme="dark"] .result-grid tr.rg-band td { background-color: #232323; }
.result-grid tbody td { transition: background-color 120ms ease; }
.result-grid tbody td.rg-sel {
  background-color: rgba(59, 130, 246, 0.16) !important;
}
[data-theme="dark"] .result-grid tbody td.rg-sel { background-color: rgba(96, 165, 250, 0.24) !important; }
.result-grid:focus { outline: none; }
.result-grid:focus-visible { outline: 1px solid rgba(59, 130, 246, 0.45); outline-offset: -1px; }
[data-theme="dark"] .result-grid td { border-color: #333; border-left-color: #2c2c2c; border-right-color: #2c2c2c; }
@media (prefers-reduced-motion: reduce) {
  .result-grid tbody td { transition: none; }
}
/* 띠 규칙보다 뒤에 — 마우스 올린 행 강조가 띠에 가려지지 않게 */
[data-theme="dark"] .result-grid tbody tr:hover td:not(:first-child) { background-color: var(--color-hover); }

/* 탭 닫기 알림의 「되돌리기」(2026-10-26) — 알림 글 옆 작은 단추 */
.closed-tab-toast { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.closed-tab-undo { border: 1px solid currentColor; background: transparent; color: inherit; border-radius: 4px; padding: 1px 8px; font: inherit; font-weight: 600; cursor: pointer; transition: background-color 150ms ease; }
.closed-tab-undo:hover { background: rgba(127, 127, 127, 0.18); }

/* 결과 표 위의 열 필터 · 값 필터 (2026-10-29) — 한 줄, 걸려 있으면 강조 */
.rg-filter-bar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 4px;
  font-size: 11px;
  color: var(--color-text-muted, #6b7280);
  min-width: 0;
}
.rg-filter-icon { flex: none; transition: color 150ms ease; }
.rg-filter-on .rg-filter-icon { color: var(--color-accent, #3b82f6); }
.rg-filter-input {
  flex: 0 1 200px;
  min-width: 80px;
  height: 22px;
  padding: 1px 6px;
  font-size: 11px;
  border: 1px solid var(--color-border, #d1d5db);
  border-radius: 3px;
  background: var(--color-bg, #fff);
  color: var(--color-text, #222);
  transition: border-color 150ms ease;
}
.rg-filter-input:focus { outline: none; border-color: var(--color-accent, #3b82f6); }
.rg-filter-count {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  animation: rg-filter-fade 150ms ease-out;
}
.rg-filter-clear {
  flex: none;
  display: inline-flex;
  align-items: center;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  transition: background-color 150ms ease, color 150ms ease;
}
.rg-filter-clear:hover { background: var(--color-bg-tertiary, #e5e7eb); color: var(--color-text, #222); }
@keyframes rg-filter-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) {
  .rg-filter-count { animation: none; }
  .rg-filter-input, .rg-filter-clear, .rg-filter-icon { transition: none; }
}

/* 사용자 주석 열(2026-10-29) — 원래 컬럼 바로 오른쪽, 결과 값과 구별되게 엷은 바탕·기울임 */
.rg-ucmt-status {
  flex: none;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 10.5px;
  white-space: nowrap;
  background: rgba(124, 58, 237, 0.10);
  color: #6d28d9;
  animation: rg-filter-fade 150ms ease-out;
}
.result-grid th.rg-ucmt-th { background: #f5f3ff; }
.rg-ucmt-head { display: block; font-weight: 600; color: #6d28d9; }
.rg-ucmt-head-src { display: block; font-size: 10px; font-weight: normal; color: #888; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rg-ucmt-cell { font-style: italic; color: #5b21b6; }
.rg-ucmt-pending { color: #aaa; }
[data-theme="dark"] .rg-ucmt-status { background: rgba(167, 139, 250, 0.16); color: #c4b5fd; }
[data-theme="dark"] .result-grid th.rg-ucmt-th { background: #2e2a3d; }
[data-theme="dark"] .rg-ucmt-head { color: #c4b5fd; }
[data-theme="dark"] .rg-ucmt-cell { color: #ddd6fe; }
@media (prefers-reduced-motion: reduce) {
  .rg-ucmt-status { animation: none; }
}
.rg-ucmt-toggle {
  display: inline-flex; align-items: center; vertical-align: -1px;
  margin-left: 4px; padding: 1px 2px; border: none; border-radius: 3px;
  background: transparent; color: #8b5cf6; cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}
.rg-ucmt-toggle:hover { background: rgba(124, 58, 237, 0.12); }
.rg-ucmt-toggle.open { background: rgba(124, 58, 237, 0.18); color: #6d28d9; }
[data-theme="dark"] .rg-ucmt-toggle { color: #a78bfa; }
[data-theme="dark"] .rg-ucmt-toggle.open { background: rgba(167, 139, 250, 0.22); color: #ddd6fe; }
.result-grid th.rg-ucmt-th .column-header-content { animation: rg-filter-fade 160ms ease-out; }
@media (prefers-reduced-motion: reduce) {
  .rg-ucmt-toggle { transition: none; }
  .result-grid th.rg-ucmt-th .column-header-content { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;;;;6CAI6C;AAC7C;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,0DAA0D;EAC1D,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,oEAAoE;EACpE,2DAA2D;EAC3D,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,wCAAwC;EACxC,gDAAgD;EAChD,4CAA4C;EAC5C,qBAAqB;EACrB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB;2DACyD;EACzD,6BAA6B;EAC7B;6EAC2E;EAC3E,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,sCAAsC;;EAEtC;;0DAEwD;EACxD,4CAA4C;EAC5C,6CAA6C;EAC7C,mDAAmD;EACnD,wDAAwD;EACxD,oDAAoD;AACtD;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;AACvC;;AAEA,sGAAsG;AACtG;;;EAGE,iCAAiC;EACjC,wBAAwB;EACxB,uCAAuC;AACzC;AACA;;;;sDAIsD;AACtD;;EAEE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;yDACyD;AACzD;EACE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;AACA;;;EAGE,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;iEACiE;AACjE,eAAe,sBAAsB,EAAE,cAAc,EAAE;AACvD,sDAAsD,cAAc,EAAE;AACtE,wBAAwB;AACxB;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,gDAAgD,EAAE,8BAA8B,CAAC;AACnF;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;;AAEA,cAAc;AACd,sBAAsB,6BAA6B,EAAE;AACrD,wBAAwB,6BAA6B,EAAE;AACvD,0CAA0C,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC1F,gDAAgD,mBAAmB,EAAE;AACrE,gDAAgD,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACjH,sDAAsD,gBAAgB,EAAE;AACxE,iDAAiD,mBAAmB,EAAE;;AAEtE,YAAY;AACZ,8CAA8C,4CAA4C,EAAE;AAC5F,kDAAkD,2BAA2B,EAAE;;AAE/E,uBAAuB;AACvB,mCAAmC,6BAA6B,EAAE;AAClE,sDAAsD,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AACtG,4DAA4D,mBAAmB,EAAE;AACjF,4DAA4D,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAC7H,2CAA2C,8BAA8B,EAAE,sBAAsB,EAAE;AACnG,wDAAwD,8BAA8B,EAAE;AACxF,gDAAgD;AAChD,0BAA0B,yBAAyB,EAAE,GAAG,iBAAiB;AACzE,0BAA0B,yBAAyB,EAAE,GAAG,oBAAoB;AAC5E,0BAA0B,yBAAyB,EAAE,GAAG,oBAAoB;AAC5E,0BAA0B,yBAAyB,EAAE,GAAG,mBAAmB;AAC3E,0BAA0B,yBAAyB,EAAE,GAAG,oBAAoB;AAC5E,0BAA0B,yBAAyB,EAAE,GAAG,mBAAmB;AAC3E,0BAA0B,yBAAyB,EAAE,GAAG,aAAa;AACrE,0BAA0B,yBAAyB,EAAE,GAAG,aAAa;AACrE,0BAA0B,yBAAyB,EAAE,GAAG,aAAa;AACrE,0BAA0B,yBAAyB,EAAE,GAAG,YAAY;AACpE,4BAA4B;AAC5B,mCAAmC,yBAAyB,EAAE;AAC9D,kCAAkC,yBAAyB,EAAE;AAC7D,kCAAkC,yBAAyB,EAAE;AAC7D,mCAAmC,yBAAyB,EAAE;AAC9D,oCAAoC,yBAAyB,EAAE;AAC/D,wCAAwC,yBAAyB,EAAE;AACnE,oCAAoC,yBAAyB,EAAE;AAC/D,wCAAwC,yBAAyB,EAAE;AACnE,uCAAuC,yBAAyB,EAAE;AAClE,mCAAmC,yBAAyB,EAAE;;AAE9D,+BAA+B;AAC/B,0CAA0C,gDAAgD,EAAE,gDAAgD,EAAE,mDAAmD,EAAE;AACnM,gDAAgD,yCAAyC,EAAE;;AAE3F,iBAAiB;AACjB,8CAA8C,qCAAqC,EAAE,iCAAiC,EAAE;AACxH,oDAAoD,kCAAkC,EAAE;;AAExF,iBAAiB;AACjB,mCAAmC,8CAA8C,EAAE;AACnF,sCAAsC,2BAA2B,EAAE,wBAAwB,EAAE,sCAAsC,EAAE;AACrI,uCAAuC,qCAAqC,EAAE,iCAAiC,EAAE;AACjH,2CAA2C,+BAA+B,EAAE;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA,yCAAyC,8BAA8B,EAAE,2BAA2B,EAAE,iCAAiC,EAAE;AACzI,8CAA8C,qCAAqC,EAAE,kCAAkC,EAAE,iCAAiC,EAAE;;AAE5J,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,qCAAqC;EACrC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAE,0BAA0B;EAC9C,iEAAiE;EACjE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,wFAAwF;EACxF,iDAAiD;EACjD,gBAAgB;EAChB,6FAA6F;EAC7F,oCAAoC;AACtC;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA,gCAAgC,aAAa,EAAE;;AAE/C,wFAAwF;AACxF,kCAAkC,gBAAgB,EAAE;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,yDAAyD;AAC3D;AACA,2BAA2B,uCAAuC,EAAE,iCAAiC,EAAE;AACvG,iCAAiC,mCAAmC,EAAE;AACtE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;8EAC8E;AAC9E;EACE,SAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,gBAAgB,EAAE;EAC1C,iBAAiB,eAAe,EAAE;EAClC,qBAAqB,gBAAgB,EAAE;AACzC;;AAEA,sCAAsC;AACtC,6CAA6C;AAC7C,6EAA6E;AAC7E,wBAAwB,gBAAgB,EAAE,SAAS,EAAE;AACrD;EACE,aAAa;EACb,eAAe,WAAW,0BAA0B;EACpD,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY,cAAc,gCAAgC;EAC1D,cAAc;EACd,gEAAgE;AAClE;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;qCACqC;AACrC,8BAA8B,iBAAiB,EAAE,EAAE,uCAAuC;AAC1F;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,wCAAwC;EACxC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oCAAoC;AACtC;;AAEA,kBAAkB,wBAAwB;EACxC,YAAY;EACZ,aAAa,EAAE,iCAAiC;EAChD,sBAAsB,EAAE,sCAAsC;EAC9D,gBAAgB,EAAE,0BAA0B;EAC5C;+EAC6E;EAC7E,cAAc;EACd,YAAY,MAAM,kGAAkG;EACpH,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA,6BAA6B;AAC7B;EACE,cAAc,EAAE,kBAAkB;EAClC,uBAAuB,EAAE,sCAAsC;EAC/D,mCAAmC,EAAE,mDAAmD;EACxF,yBAAyB,EAAE,sBAAsB;EACjD,sBAAsB,EAAE,gDAAgD;EACxE,WAAW,EAAE,iDAAiD;EAC9D,kBAAkB,EAAE,mBAAmB;AACzC;;AAEA,wBAAwB,wBAAwB;EAC9C,YAAY;EACZ,aAAa,EAAE,gCAAgC;EAC/C,aAAa,EAAE,wBAAwB;EACvC,YAAY,GAAG,8DAA8D;EAC7E,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;;;qEAGqE;AACrE;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,kCAAkC;EAClC,cAAc;EACd,mDAAmD;EACnD,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,sBAAsB,gBAAgB,EAAE;AAC1C;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,wCAAwC;EACxC,4BAA4B;EAC5B,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,wFAAwF;EACxF,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wFAAwF;AAC1F;AACA;EACE,wFAAwF;AAC1F;AACA;EACE,wFAAwF;AAC1F;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAE,gEAAgE;EAChF,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,kFAAkF;AACpF;AACA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA,8BAA8B;;;;;;;4DAO8B;EAC1D,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA,0BAA0B,uCAAuC;EAC/D,YAAY;EACZ,cAAc,EAAE,cAAc;EAC9B,gDAAgD;EAChD,aAAa,EAAE,qCAAqC;EACpD,sBAAsB,EAAE,OAAO;EAC/B,aAAa,EAAE,sBAAsB;EACrC,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,uBAAuB,EAAE,oBAAoB;EAC7C,cAAc,EAAE,oBAAoB;EACpC,gCAAgC;EAChC;;;;kEAIgE;EAChE,YAAY,EAAE,yBAAyB;EACvC,cAAc,EAAE,cAAc;EAC9B,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,sDAAsD;EACtD,yBAAyB,EAAE,kBAAkB;EAC7C,uBAAuB;EACvB,2BAA2B,EAAE,aAAa;AAC5C;;AAEA,qFAAqF;AACrF,4BAA4B;AAC5B;EACE;;0CAEwC;EACxC,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,oJAAoJ;AACpJ,mGAAmG;AACnG,0FAA0F;;AAE1F,yCAAyC;AACzC;EACE,SAAW;EACX,aAAa;EACb,YAAY,WAAW,8GAA8G;EACrI,gBAAgB;EAChB,cAAc;EACd;+FAC6F;EAC7F,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB,EAAE,gBAAgB;EACrC;sEACoE;EACpE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;;iDAE+C;EAC/C,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;;;4EAG4E;AAC5E;EACE,qBAAqB,MAAM,gDAAgD;EAC3E,mBAAmB,QAAQ,kCAAkC;EAC7D,wEAAwE;;EAExE;;;6DAG2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;EAChB,gEAAgE;EAChE,kDAAkD;EAClD,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;EAC1C,iBAAiB,QAAQ,8BAA8B;EACvD,gBAAgB,EAAE,UAAU;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB,QAAQ,8CAA8C;EACvE,gBAAgB,EAAE,UAAU;EAC5B;;iCAE+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;kEAEkE;AAClE;EACE,aAAa;EACb,eAAe;EACf;0CACwC;EACxC,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qDAAqD;AACvD;AACA,wBAAwB,eAAe,EAAE;AACzC;qCACqC,mBAAmB,EAAE,cAAc,EAAE;;AAE1E,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;mFAEmF;AACnF;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;;EAEE,cAAc;EACd,yCAAyC;AAC3C;AACA;;EAEE,yBAAyB,IAAI,mCAAmC;EAChE,oCAAoC;AACtC;AACA;EACE;yBACuB,gBAAgB,EAAE;AAC3C;;AAEA,6EAA6E;AAC7E;EACE,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,mBAAmB,EAAE,0CAA0C;AACjE;AACA;0DAC0D;AAC1D;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,+EAA+E;EAC/E,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,yEAAyE;AAC3E;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;;AAGA,mDAAmD;AACnD;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;;4CAE0C;EAC1C,0FAA0F;EAC1F,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B;+CAC6C;EAC7C,yEAAyE;EACzE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB,iBAAiB,EAAE;AAC3C,2DAA2D;AAC3D,0CAA0C,gBAAgB,EAAE;;AAE5D;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;AAEA;6DAC6D;AAC7D;EACE;gDAC8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,gBAAgB,EAAE;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc;AACd,sDAAsD;AACtD;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA,sCAAsC,kBAAkB,EAAE;;AAE1D;EACE,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB;qDACmD;EACnD,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;;;oDAGoD;AACpD;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAE,eAAe;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,WAAW,EAAE,0BAA0B;EACvC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;;EAEE,gBAAgB;AAClB;;AAEA;;;;iEAIiE;AACjE;EACE,iBAAiB;EACjB,kCAAkC,EAAE,mCAAmC;AACzE;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,gBAAgB;EAChB,OAAO,EAAE,eAAe;EACxB,oCAAoC;EACpC,8CAA8C;EAC9C,8CAA8C;EAC9C,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,kDAAkD;EAClD,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,kEAAkE;AAClE;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW,EAAE,iBAAiB;EAC9B,WAAW;EACX,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;sCACsC;AACtC;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,iCAAiC;AACnC;AACA;;EAEE,sDAAsD;EACtD,yCAAyC;EACzC,iDAAiD;AACnD;AACA;EACE,qDAAqD;AACvD;;AAEA,kBAAkB;AAClB,mCAAmC,wBAAwB,EAAE;AAC7D,sCAAsC,+CAA+C,EAAE,4CAA4C,EAAE,uDAAuD,EAAE;AAC9L,4CAA4C,4CAA4C,EAAE,yCAAyC,EAAE;AACrI,4CAA4C,0CAA0C,EAAE,yBAAyB,EAAE;AACnH,0CAA0C,0CAA0C,EAAE,yBAAyB,EAAE;AACjH,oCAAoC,wBAAwB,EAAE;AAC9D,mCAAmC,iCAAiC,EAAE;AACtE,yCAAyC,8BAA8B,EAAE;AACzE,4CAA4C,qDAAqD,EAAE,qCAAqC,EAAE;AAC1I,yCAAyC,iCAAiC,EAAE,kCAAkC,EAAE;AAChH,wDAAwD,wBAAwB,EAAE;AAClF,sCAAsC,cAAc,EAAE;AACtD,2CAA2C,iCAAiC,EAAE;AAC9E,yCAAyC,iCAAiC,EAAE;AAC5E,+DAA+D,cAAc,EAAE;AAC/E,6DAA6D,cAAc,EAAE;AAC7E,8CAA8C,wBAAwB,EAAE,iCAAiC,EAAE;AAC3G,gEAAgE;AAChE,6DAA6D,kCAAkC,EAAE;AACjG,kDAAkD,gBAAgB,EAAE,8BAA8B,EAAE;AACpG,wDAAwD,mBAAmB,EAAE,WAAW,EAAE;AAC1F;qCACqC;AACrC;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA,yDAAyD;AACzD,qDAAqD;AACrD,uCAAuC,iCAAiC,EAAE,wCAAwC,EAAE;AACpH;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,wBAAwB;AAC1B;AACA,kDAAkD,kCAAkC,EAAE;AACtF;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA,8CAA8C,qCAAqC,EAAE,iCAAiC,EAAE,wBAAwB,EAAE;AAClJ,6CAA6C,wCAAwC,EAAE;AACvF,gDAAgD,wBAAwB,EAAE;AAC1E,0CAA0C,8BAA8B,EAAE;AAC1E,gDAAgD,oCAAoC,EAAE,wBAAwB,EAAE;AAChH,kCAAkC,kCAAkC,EAAE;AACtE,uCAAuC,8BAA8B,EAAE;AACvE,mCAAmC,wCAAwC,EAAE,oCAAoC,EAAE,cAAc,EAAE;AACnI,8CAA8C,qCAAqC,EAAE;AACrF,2CAA2C,kCAAkC,EAAE,iCAAiC,EAAE;AAClH,sCAAsC,2BAA2B,EAAE,iCAAiC,EAAE,wBAAwB,EAAE;AAChI,+CAA+C,gCAAgC,EAAE,0BAA0B,EAAE;AAC7G,+CAA+C,gCAAgC,EAAE,0BAA0B,EAAE;AAC7G,6CAA6C,+BAA+B,EAAE,wBAAwB,EAAE,iCAAiC,EAAE;AAC3I,mDAAmD,8BAA8B,EAAE;AACnF,mDAAmD,mBAAmB,EAAE;AACxE,6CAA6C,8BAA8B,EAAE;AAC7E,mDAAmD,cAAc,EAAE;AACnE,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf;;2DAEyD;EACzD,SAAO;EACP,aAAa;AACf;;AAEA,qCAAqC,4CAA4C,EAAE;AACnF,oCAAoC,4CAA4C,EAAE;AAClF,8CAA8C,4CAA4C,EAAE;;AAE5F,wCAAwC;AACxC;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gEAAgE;AAClE;AACA,4BAA4B,uCAAuC,EAAE,0CAA0C,EAAE;AACjH,0CAA0C,sBAAsB,gBAAgB,EAAE,EAAE;;AAEpF,gCAAgC;AAChC;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;AACA,iCAAiC,0CAA0C,EAAE;AAC7E,0CAA0C,2BAA2B,gBAAgB,EAAE,EAAE;;AAEzF;uCACuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;sEACsE;AACtE;;EAEE,gBAAgB;EAChB,uCAAuC;AACzC;AACA,6BAA6B,UAAU,EAAE;AACzC,6BAA6B,WAAW,EAAE,0CAA0C,EAAE;AACtF,gCAAgC,mDAAmD,EAAE;AACrF,mDAAmD;AACnD;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;AACA,8CAA8C,WAAW,EAAE;AAC3D,+CAA+C,WAAW,EAAE,yBAAyB,EAAE,oCAAoC,EAAE;AAC7H,wCAAwC,iDAAiD,EAAE;AAC3F,yCAAyC;AACzC,+CAA+C,yBAAyB,EAAE,gBAAgB,EAAE;AAC5F,iDAAiD,iCAAiC,EAAE;AACpF,uDAAuD,yBAAyB,EAAE;AAClF,mEAAmE,oCAAoC,EAAE,yBAAyB,EAAE;AACpI,mEAAmE,yBAAyB,EAAE;;AAE9F,eAAe;AACf;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;AACA,8CAA8C,mBAAmB,EAAE;AACnE,kCAAkC,cAAc,EAAE,eAAe,EAAE;AACnE,sCAAsC,6CAA6C,EAAE,0CAA0C,EAAE;AACjI,6CAA6C,8BAA8B,EAAE;AAC7E,kEAAkE,uCAAuC,EAAE;AAC3G,sDAAsD,oCAAoC,EAAE;AAC5F;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,kBAAkB,eAAe,EAAE;EACnC,yBAAyB,gBAAgB,EAAE;AAC7C;;AAEA,qEAAqE;AACrE,YAAY,wBAAwB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,uCAAuC,EAAE;AACnJ,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/I,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;AAC1C,2BAA2B,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACjH,gCAAgC,mCAAmC,EAAE,qBAAqB,EAAE;AAC5F,sCAAsC,cAAc,EAAE;AACtD,4CAA4C,cAAc,EAAE;AAC5D,8CAA8C,cAAc,EAAE;AAC9D,0CAA0C,YAAY,eAAe,EAAE,EAAE;;AAEzE;kFACkF;AAClF,qDAAqD;AACrD,wBAAwB,uCAAuC,EAAE;AACjE,6BAA6B,yBAAyB,EAAE;AACxD,iDAAiD,yBAAyB,EAAE;AAC5E,wBAAwB,uCAAuC,EAAE;AACjE;EACE,qDAAqD;AACvD;AACA,mDAAmD,qDAAqD,EAAE;AAC1G,qBAAqB,aAAa,EAAE;AACpC,6BAA6B,2CAA2C,EAAE,oBAAoB,EAAE;AAChG,sCAAsC,kBAAkB,EAAE,0BAA0B,EAAE,2BAA2B,EAAE;AACnH;EACE,wBAAwB,gBAAgB,EAAE;AAC5C;AACA,wCAAwC;AACxC,uEAAuE,oCAAoC,EAAE;;AAE7G,+CAA+C;AAC/C,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC3F,mBAAmB,8BAA8B,EAAE,uBAAuB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE,uCAAuC,EAAE;AAC7N,yBAAyB,qCAAqC,EAAE;;AAEhE,sDAAsD;AACtD;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,YAAY;AACd;AACA,kBAAkB,UAAU,EAAE,4BAA4B,EAAE;AAC5D,gCAAgC,mCAAmC,EAAE;AACrE;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;AACrC;AACA,yBAAyB,aAAa,EAAE,0CAA0C,EAAE;AACpF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yDAAyD;AAC3D;AACA,yBAAyB,6CAA6C,EAAE,8BAA8B,EAAE;AACxG,4BAA4B,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAClH;EACE,mBAAmB,eAAe,EAAE;EACpC,sDAAsD,gBAAgB,EAAE;AAC1E;;AAEA,8DAA8D;AAC9D;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;AACA,6BAA6B,mBAAmB,EAAE;AAClD,gBAAgB,cAAc,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,oBAAoB,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvJ,gBAAgB,kBAAkB,EAAE,cAAc,EAAE;AACpD,mBAAmB,WAAW,EAAE;AAChC,sCAAsC,qCAAqC,EAAE,cAAc,EAAE;AAC7F,iDAAiD,mBAAmB,EAAE;AACtE,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,cAAc,EAAE;AACpD;EACE,kBAAkB,eAAe,EAAE;AACrC;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,oBAAoB;EAC/D,gBAAgB,EAAE,gBAAgB,EAAE,YAAY,EAAE,kBAAkB;EACpE,uBAAuB,EAAE,cAAc,EAAE,eAAe;EACxD,yDAAyD;AAC3D;AACA,wBAAwB,oCAAoC,EAAE;AAC9D,uBAAuB,oCAAoC,EAAE,cAAc,EAAE;AAC7E,sCAAsC,cAAc,EAAE;AACtD,2CAA2C,qCAAqC,EAAE,cAAc,EAAE;AAClG,oDAAoD,wCAAwC,EAAE;AAC9F;EACE,kBAAkB,gBAAgB,EAAE;EACpC,oDAAoD,eAAe,EAAE;AACvE","sourcesContent":["/* App.css */\r\n\r\n/* ========================================\r\n   글로벌 폰트 정책 (DBeaver 스타일 참고)\r\n   - UI 텍스트: Segoe UI, 12px\r\n   - 코드/데이터: Consolas, 13px\r\n   ======================================== */\r\n:root {\r\n  --color-success-bg: #d4edda;\r\n  --color-success-text: #155724;\r\n  --color-error-bg: #f8d7da;\r\n  --color-error-text: #721c24;\r\n  --color-quiz-success-bg: #e8f5e8;\r\n  --color-quiz-success-border: #c8e6c8;\r\n  --color-quiz-success-text: #2e7d32;\r\n  --color-quiz-fail-bg: #ffebee;\r\n  --color-quiz-fail-border: #ffcdd2;\r\n  --color-quiz-fail-text: #c62828;\r\n  /* 챌린지 주의·성공 패널 — 다크모드에서 흰 상자로 남지 않게 변수로 둔다 (2026-09-19) */\r\n  --color-quiz-warn-bg: #fff3cd;\r\n  --color-quiz-warn-border: #ffeaa7;\r\n  --color-quiz-warn-text: #856404;\r\n  --color-quiz-ok-border: #c3e6c3;\r\n  --color-quiz-selected-bg: #eef2f7;\r\n  --color-quiz-no-data-bg: #fff;\r\n  --color-quiz-no-data-border: #bbb;\r\n  --color-quiz-no-data-text: #333;\r\n  --font-ui: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  --font-mono: 'Consolas', 'Monaco', 'Courier New', monospace;\r\n  --font-size-ui: 12px;\r\n  --font-size-ui-small: 11px;\r\n  --font-size-mono: 13px;\r\n  --font-size-grid: 12px;\r\n  --font-size-tree: 12px;\r\n  --font-size-tab: 12px;\r\n  --color-text: #333;\r\n  --color-text-secondary: #666;\r\n  --color-text-muted: #999;\r\n  --color-bg: #ffffff;\r\n  --color-bg-secondary: #f5f6f8;\r\n  --color-bg-tertiary: #e8ecf0;\r\n  --color-border: #ddd;\r\n  --color-border-light: #eee;\r\n  --color-header-bg: #ffffff;\r\n  --color-tab-bg: #f0f0f0;\r\n  --color-tab-active: #ffffff;\r\n  --color-grid-header: #f2f2f2;\r\n  --color-grid-border: #ddd;\r\n  --color-overlay-bg: rgba(0, 0, 0, 0.5);\r\n  --color-accent: #3b82f6;\r\n  --color-hover-border: #c4c4c4;\r\n  --color-accent-fg: #2563eb;\r\n  --color-accent-hover: #2563eb;\r\n}\r\n\r\n/* 다크모드 */\r\n[data-theme=\"dark\"] {\r\n  --color-success-bg: #1e4620;\r\n  --color-success-text: #81c784;\r\n  --color-error-bg: #5a1e20;\r\n  --color-error-text: #e57373;\r\n  --color-quiz-success-bg: #1b4332;\r\n  --color-quiz-success-border: #2d6a4f;\r\n  --color-quiz-success-text: #74c69d;\r\n  --color-quiz-fail-bg: #4a151b;\r\n  --color-quiz-fail-border: #7a2228;\r\n  --color-quiz-fail-text: #ff8a80;\r\n  --color-quiz-warn-bg: #4a3c0f;\r\n  --color-quiz-warn-border: #6b5514;\r\n  --color-quiz-warn-text: #ffd76e;\r\n  --color-quiz-ok-border: #2d6a4f;\r\n  --color-quiz-selected-bg: #2a3340;\r\n  --color-quiz-no-data-bg: var(--color-bg);\r\n  --color-quiz-no-data-border: var(--color-border);\r\n  --color-quiz-no-data-text: var(--color-text);\r\n  --color-text: #d4d4d4;\r\n  --color-text-secondary: #aaa;\r\n  --color-text-muted: #777;\r\n  --color-bg: #1e1e1e;\r\n  --color-bg-secondary: #252526;\r\n  --color-bg-tertiary: #2d2d2d;\r\n  --color-border: #404040;\r\n  --color-border-light: #333;\r\n  --color-header-bg: #252526;\r\n  --color-tab-bg: #2d2d2d;\r\n  --color-tab-active: #1e1e1e;\r\n  --color-grid-header: #2d2d2d;\r\n  --color-grid-border: #404040;\r\n  --color-input-bg: #3c3c3c;\r\n  --color-input-border: #555;\r\n  --color-hover: #37373d;\r\n  /* 호버는 파란 강조색이 아니라 한 단계 밝은 배경 + 회색 테두리로 한다(사용자 요청 2026-09-13).\r\n     파랑은 \"선택됨·주 버튼\" 에만 쓴다 — 호버까지 파랗면 무엇이 켜져 있는지 구분이 안 된다. */\r\n  --color-hover-border: #5a5a5a;\r\n  /* 강조색을 **글자·테두리**에 쓸 때의 색. #007acc 는 어두운 배경에서 대비가 낮아 잘 안 보였다\r\n     (사용자 지적 2026-09-13 — 헤더 확대 비율·탐색기 연결 버튼). 채운 버튼 배경은 --color-accent 그대로 */\r\n  --color-accent-fg: #6cb6ff;\r\n  --color-active: #094771;\r\n  --color-accent: #007acc;\r\n  --color-btn-bg: #3c3c3c;\r\n  --color-btn-border: #555;\r\n  --color-modal-bg: #2d2d2d;\r\n  --color-scrollbar-bg: #1e1e1e;\r\n  --color-scrollbar-thumb: #555;\r\n  --color-overlay-bg: rgba(0, 0, 0, 0.6);\r\n\r\n  /* react-toastify — 라이브러리 기본 dark 는 #121212 라 앱 표면(#2d2d2d)보다 어둡다.\r\n     떠 있는 알림이 배경보다 가라앉아 보이므로 앱의 모달과 같은 층으로 맞춘다.\r\n     아이콘 기본색(#07bc0c·#e74c3c)은 다크에서 과채도라 앱의 성공/실패 색을 쓴다. */\r\n  --toastify-color-dark: var(--color-modal-bg);\r\n  --toastify-text-color-dark: var(--color-text);\r\n  --toastify-color-progress-dark: var(--color-accent);\r\n  --toastify-icon-color-success: var(--color-success-text);\r\n  --toastify-icon-color-error: var(--color-error-text);\r\n}\r\n\r\n/* 알림은 어두운 배경 위에 뜨므로 경계가 있어야 표면으로 읽힌다 */\r\n[data-theme=\"dark\"] .Toastify__toast {\r\n  border: 1px solid var(--color-border);\r\n}\r\n\r\n/* 다크모드 전역 오버라이드 — type=checkbox/radio 는 제외해서 color-scheme + accent-color 가 native 위젯 렌더에 정상 작동하게 함. */\r\n[data-theme=\"dark\"] input:not([type=\"checkbox\"]):not([type=\"radio\"]),\r\n[data-theme=\"dark\"] select,\r\n[data-theme=\"dark\"] textarea {\r\n  background: var(--color-input-bg);\r\n  color: var(--color-text);\r\n  border-color: var(--color-input-border);\r\n}\r\n/* 위에서 checkbox/radio 를 제외했으면 **여기서 받아 줘야 한다.** 그 규칙이 없어서 다크모드에\r\n   흰 네모와 밝은 파란 체크가 그대로 떠 있었다(지적 2026-09-19 — 쿼리 챌린지의 난이도·공개\r\n   여부 등 여러 군데). 컴포넌트마다 따로 칠하던 것을 여기 한 곳으로 모은다.\r\n     · color-scheme: dark  → 네모의 배경·테두리를 브라우저가 어두운 쪽으로 그린다\r\n     · accent-color        → 체크됐을 때의 채움색을 앱 강조색에 맞춘다 */\r\n[data-theme=\"dark\"] input[type=\"checkbox\"],\r\n[data-theme=\"dark\"] input[type=\"radio\"] {\r\n  color-scheme: dark;\r\n  accent-color: var(--color-accent-fg);\r\n}\r\n/* 자동 완성 목록(datalist)이 있는 입력 칸 — 그 목록은 브라우저가 그리는 창이라 CSS 로 칠할 수 없고 color-scheme 만 따른다.\r\n   없으면 다크모드에 흰 목록이 뜬다(지적 2026-10-16 — 오라클 성능 분석의 대기 검색) */\r\n[data-theme=\"dark\"] input[list] {\r\n  color-scheme: dark;\r\n}\r\n\r\n[data-theme=\"dark\"] input::placeholder,\r\n[data-theme=\"dark\"] textarea::placeholder {\r\n  color: var(--color-text-muted);\r\n}\r\n[data-theme=\"dark\"] input:focus,\r\n[data-theme=\"dark\"] select:focus,\r\n[data-theme=\"dark\"] textarea:focus {\r\n  outline: none;\r\n  border-color: var(--color-accent-fg);\r\n}\r\n[data-theme=\"dark\"] button {\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] pre {\r\n  color: var(--color-text);\r\n}\r\n/* 아이콘+레이블 버튼 — 아이콘(svg)이 글자 기준선에 앉으면 줄 상자가 위로 늘어 레이블이 아래로 치우쳐 보인다.\r\n   인라인 버튼은 아이콘을 글자 가운데에 맞춘다(flex 버튼은 align-items 가 맡으므로 영향 없다). */\r\nbutton > svg { vertical-align: middle; flex-shrink: 0; }\r\n.detach-inline-btn > svg, .split-collapse-btn > svg { display: block; }\r\n/* CodeMirror 전역 폰트 통일 */\r\n.cm-editor, .cm-content, .cm-line, .cm-gutters {\r\n  font-family: var(--font-mono) !important;\r\n  font-size: var(--font-size-mono) !important;\r\n}\r\n\r\n[data-theme=\"dark\"] .cm-editor {\r\n  background: var(--color-bg) !important;\r\n}\r\n[data-theme=\"dark\"] .cm-gutters {\r\n  background: var(--color-bg-secondary) !important;\r\n  border-color: var(--color-border) !important;\r\n  color: var(--color-text-muted) !important;\r\n}\r\n[data-theme=\"dark\"] .cm-content {\r\n  color: var(--color-text) !important;\r\n}\r\n[data-theme=\"dark\"] .cm-activeLine {\r\n  background: rgba(255,255,255,0.04) !important;\r\n}\r\n[data-theme=\"dark\"] .cm-selectionBackground {\r\n  background: #264f78 !important;\r\n}\r\n[data-theme=\"dark\"] .result-grid td {\r\n  color: var(--color-text);\r\n  border-color: var(--color-grid-border);\r\n}\r\n[data-theme=\"dark\"] .result-grid tr:hover td {\r\n  background: var(--color-hover);\r\n}\r\n[data-theme=\"dark\"] .sql-editor-minimap {\r\n  background: rgba(37,37,38,0.85);\r\n  border-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .detach-inline-btn {\r\n  color: var(--color-text-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .detach-inline-btn:hover {\r\n  color: var(--color-text);\r\n  border-color: var(--color-hover-border, #5a5a5a); background: var(--color-hover);}\r\n[data-theme=\"dark\"] .editor-search-bar {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .editor-search-input {\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .editor-search-nav {\r\n  color: var(--color-text-secondary);\r\n}\r\n[data-theme=\"dark\"] .editor-search-nav:hover {\r\n  background: var(--color-hover);\r\n}\r\n[data-theme=\"dark\"] .detach-rejoin-bar {\r\n  background: #1a3a5c;\r\n  border-color: #264f78;\r\n  color: #6cb6ff;\r\n}\r\n[data-theme=\"dark\"] .split-view-divider {\r\n  background: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .split-view-divider-handle {\r\n  background: var(--color-text-muted);\r\n}\r\n\r\n/* 스크롤바 다크모드 */\r\n[data-theme=\"dark\"] { scrollbar-color: #555 #1e1e1e; }\r\n[data-theme=\"dark\"] * { scrollbar-color: #555 #1e1e1e; }\r\n[data-theme=\"dark\"] ::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }\r\n[data-theme=\"dark\"] ::-webkit-scrollbar-track { background: #1e1e1e; }\r\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }\r\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb:hover { background: #666; }\r\n[data-theme=\"dark\"] ::-webkit-scrollbar-corner { background: #1e1e1e; }\r\n\r\n/* 에디터 테두리 */\r\n[data-theme=\"dark\"] .codemirror-editor-area { border-color: var(--color-border) !important; }\r\n[data-theme=\"dark\"] .sql-editor-inner-container { background: var(--color-bg); }\r\n\r\n/* CodeMirror 세부 다크모드 */\r\n[data-theme=\"dark\"] .cm-scroller { scrollbar-color: #555 #1e1e1e; }\r\n[data-theme=\"dark\"] .cm-scroller::-webkit-scrollbar { background: #1e1e1e; width: 12px; height: 12px; }\r\n[data-theme=\"dark\"] .cm-scroller::-webkit-scrollbar-track { background: #1e1e1e; }\r\n[data-theme=\"dark\"] .cm-scroller::-webkit-scrollbar-thumb { background: #555; border-radius: 4px; border: 2px solid #1e1e1e; }\r\n[data-theme=\"dark\"] .cm-activeLineGutter { background: #264f78 !important; color: #fff !important; }\r\n[data-theme=\"dark\"] .cm-lineNumbers .cm-gutterElement { color: var(--color-text-muted); }\r\n/* CodeMirror 구문 하이라이팅 다크모드 (VS Code Dark+ 색상) */\r\n[data-theme=\"dark\"] .ͼb { color: #9cdcfe !important; }  /* variableName */\r\n[data-theme=\"dark\"] .ͼc { color: #d4d4d4 !important; }  /* comment → 밝은 회색 */\r\n[data-theme=\"dark\"] .ͼd { color: #6a9955 !important; }  /* comment (green) */\r\n[data-theme=\"dark\"] .ͼe { color: #569cd6 !important; }  /* keyword (blue) */\r\n[data-theme=\"dark\"] .ͼf { color: #ce9178 !important; }  /* string (orange) */\r\n[data-theme=\"dark\"] .ͼg { color: #b5cea8 !important; }  /* number (green) */\r\n[data-theme=\"dark\"] .ͼi { color: #c586c0 !important; }  /* operator */\r\n[data-theme=\"dark\"] .ͼl { color: #dcdcaa !important; }  /* function */\r\n[data-theme=\"dark\"] .ͼm { color: #4ec9b0 !important; }  /* typeName */\r\n[data-theme=\"dark\"] .ͼn { color: #569cd6 !important; }  /* keyword */\r\n/* 범용: CodeMirror 하이라이트 토큰 */\r\n[data-theme=\"dark\"] .tok-keyword { color: #569cd6 !important; }\r\n[data-theme=\"dark\"] .tok-string { color: #ce9178 !important; }\r\n[data-theme=\"dark\"] .tok-number { color: #b5cea8 !important; }\r\n[data-theme=\"dark\"] .tok-comment { color: #6a9955 !important; }\r\n[data-theme=\"dark\"] .tok-operator { color: #c586c0 !important; }\r\n[data-theme=\"dark\"] .tok-variableName { color: #9cdcfe !important; }\r\n[data-theme=\"dark\"] .tok-typeName { color: #4ec9b0 !important; }\r\n[data-theme=\"dark\"] .tok-propertyName { color: #9cdcfe !important; }\r\n[data-theme=\"dark\"] .tok-punctuation { color: #d4d4d4 !important; }\r\n[data-theme=\"dark\"] .tok-bracket { color: #ffd700 !important; }\r\n\r\n/* 메인 탭(쿼리결과/실행계획/테이블정보) 다크모드 */\r\n[data-theme=\"dark\"] .Resizer.horizontal { background: var(--color-bg-secondary) !important; border-top-color: var(--color-border) !important; border-bottom-color: var(--color-border) !important; }\r\n[data-theme=\"dark\"] .Resizer.horizontal:hover { background: var(--color-hover) !important; }\r\n\r\n/* 에디터 바인드변수 영역 */\r\n[data-theme=\"dark\"] .bind-variables-section { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .bind-variables-toggle-header { color: var(--color-text-secondary); }\r\n\r\n/* 줌 버튼 다크모드 보완 */\r\n[data-theme=\"dark\"] .result-grid { background: var(--rg-outside-bg-dark, #161616); }\r\n[data-theme=\"dark\"] .result-grid td { background: var(--color-bg); color: var(--color-text); border-color: var(--color-grid-border); }\r\n[data-theme=\"dark\"] .side-panel-area { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .file-tabs-container { background: var(--color-tab-bg); }\r\n.result-grid-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 32px 16px;\r\n  color: #6b7280;\r\n  background: #fafafa;\r\n  border: 1px dashed #e5e7eb;\r\n  border-radius: 6px;\r\n  margin: 8px;\r\n  font-size: 13px;\r\n  min-height: 80px;\r\n}\r\n[data-theme=\"dark\"] .result-grid-empty { color: var(--color-text-muted); background: var(--color-bg); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .loading-more-indicator { background: var(--color-bg-secondary); color: var(--color-text-secondary); border-color: var(--color-border); }\r\n\r\n/* 앱 푸터 */\r\n.app-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 3px 12px;\r\n  font-size: 10px;\r\n  color: var(--color-text-muted);\r\n  background: var(--color-bg-secondary);\r\n  border-top: 1px solid var(--color-border);\r\n  flex-shrink: 0;\r\n}\r\n.app-footer-sep {\r\n  color: var(--color-border);\r\n}\r\n\r\nbody, button, input, select, textarea {\r\n  font-family: var(--font-ui);\r\n  font-size: var(--font-size-ui);\r\n  color: var(--color-text);\r\n}\r\n\r\n.app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100vh / var(--app-zoom, 1));\r\n  font-family: var(--font-ui);\r\n  font-size: var(--font-size-ui);\r\n  background: var(--color-bg);\r\n  color: var(--color-text);\r\n}\r\n\r\n.content-area {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-grow: 1;\r\n  overflow: hidden;\r\n  position: relative; /* 토글 버튼의 absolute 위치 기준 */\r\n  /* 헤더 높이만큼 content-area의 시작점을 내리거나, 헤더가 absolute가 아니라면 자연스럽게 밀림 */\r\n  /* App.js 에서 Header 다음이므로, Header 높이만큼 자동으로 밀립니다. */\r\n}\r\n\r\n.schema-explorer-area {\r\n  flex: 0 0 280px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-right: 1px solid var(--color-border);\r\n  background: var(--color-bg-secondary);\r\n  /* 접기(utils/explorerLayout.js) — 오른쪽 패널(.side-panel-area · AI 에이전트)과 **같은 시간**으로 미닫이처럼 */\r\n  transition: font-size 0.1s, flex-basis 260ms ease;\r\n  overflow: hidden;\r\n  /* SchemaExplorer.module.css 의 .schemaExplorerContainer 에 flex-grow:1 및 min-height:0 설정이 중요 */\r\n  /* 내부 스크롤은 SchemaExplorer 컴포넌트가 담당 */\r\n}\r\n\r\n/* 탐색기 본문 — 접혀도 마운트된 채 숨는다(hidden). 남는 높이를 탐색기·책갈피가 나눠 쓴다 */\r\n.schema-explorer-body {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.schema-explorer-body[hidden] { display: none; }\r\n\r\n/* 접힌 탐색기 = 아이콘 띠(사용자 결정 2026-10-10). 폭은 utils/explorerLayout EXPLORER_RAIL_WIDTH 와 같다 */\r\n.schema-explorer-area.collapsed { flex-basis: 32px; }\r\n.explorer-rail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 6px 0;\r\n  animation: explorer-rail-in 160ms ease-out;\r\n}\r\n.explorer-rail-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--color-text-muted, #6b7280);\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, color 150ms ease;\r\n}\r\n.explorer-rail-btn:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }\r\n.explorer-rail-btn:first-child { color: var(--color-accent, #2f6fb0); }\r\n@keyframes explorer-rail-in {\r\n  from { opacity: 0; transform: translateX(-3px); }\r\n  to { opacity: 1; transform: none; }\r\n}\r\n\r\n/* 편집기+결과 칸 — 오른쪽 패널이 열려도 이보다 좁아지지 않는다(utils/explorerLayout EDITOR_MIN_WIDTH).\r\n   모자라면 패널 쪽이 줄어든다 — 사이드 패널은 flex-shrink 1, 데이터 분석·AI 에이전트는 각자의 min-width 까지 */\r\n.editor-result-column {\r\n  flex: 1 1 0;\r\n  min-width: 480px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .schema-explorer-area { transition: none; }\r\n  .explorer-rail { animation: none; }\r\n  .explorer-rail-btn { transition: none; }\r\n}\r\n\r\n/* 에디터 툴바 액션 아이콘 그룹 (검색 바 옆에 가로로 배치) */\r\n/* 공간이 좁아지면(예: SQL 튜닝 패널 펼침) 아이콘이 자동으로 줄바꿈됨 */\r\n/* 툴바 줄바꿈 — 이 뒤의 도구 창 단추는 늘 다음 줄(EditorToolbarRight). 폭 100% 짜리 빈 칸이 줄을 끊는다 */\r\n.editor-toolbar-break { flex-basis: 100%; height: 0; }\r\n.editor-action-group {\r\n  display: flex;\r\n  flex-wrap: wrap;          /* 공간 부족 시 서브그룹 단위로 다음 줄 */\r\n  align-items: center;\r\n  row-gap: 4px;\r\n  column-gap: 4px;\r\n  min-width: 0;             /* flex 축소 허용 — 이게 있어야 wrap 작동 */\r\n  flex-shrink: 1;\r\n  /* 우측 끝 여백은 사용처의 inline style padding-right 로 적용 (인라인 우선순위 회피) */\r\n}\r\n\r\n/* 서브그룹: separator 로 구분된 묶음. 내부는 절대 줄바꿈 금지 (그룹 단위로만 wrap) */\r\n.editor-action-subgroup {\r\n  display: inline-flex;\r\n  flex-wrap: nowrap;\r\n  gap: 4px;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 오른쪽 정렬 시작점: 이 subgroup 부터 우측 정렬됨 (공간 남을 때)\r\n   wrap 되어 줄이 바뀌면 해당 줄 안에서 우측 정렬 유지 */\r\n.editor-toolbar-editor-part { display: contents; } /* 편집기 쪽 툴바 묶음 — 숨기면 검색~창 분리가 함께 사라진다 */\r\n.editor-action-subgroup.right-align {\r\n  margin-left: auto;\r\n}\r\n\r\n.editor-action-btn {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  color: var(--color-text-secondary, #555);\r\n  padding: 0;\r\n  transition: background 0.12s, color 0.12s, border-color 0.12s;\r\n}\r\n\r\n.editor-action-btn:hover {\r\n  background: var(--color-hover, #e5e7eb);\r\n  color: var(--color-text, #222);\r\n  border-color: var(--color-border, #ddd);\r\n}\r\n\r\n.editor-action-btn:active {\r\n  background: var(--color-bg-tertiary, #d1d5db);\r\n}\r\n\r\n/* 토글 ON 상태 (예: 컬럼 선택 모드) */\r\n.editor-action-btn.active {\r\n  background: var(--color-accent, #3b82f6);\r\n  color: #ffffff;\r\n  border-color: var(--color-accent, #3b82f6);\r\n}\r\n\r\n.editor-action-btn.active:hover {\r\n  background: var(--color-accent, #2563eb);\r\n  color: #ffffff;\r\n  border-color: var(--color-accent, #2563eb);\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* 가로 방향 구분선 (세로 세로줄) */\r\n.editor-action-sep-v {\r\n  display: inline-block;\r\n  width: 1px;\r\n  height: 16px;\r\n  background: var(--color-border, #ddd);\r\n  margin: 0 4px;\r\n}\r\n\r\n/* AA / aa 텍스트 아이콘 */\r\n.editor-action-text {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  font-family: Menlo, Monaco, Consolas, monospace;\r\n  line-height: 1;\r\n}\r\n\r\n[data-theme=\"dark\"] .editor-action-btn {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .editor-action-btn:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .editor-action-sep-v {\r\n  background: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .editor-action-btn.active {\r\n  background: var(--color-accent);\r\n  color: #ffffff;\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n.main-work-area { /* 기존 .main-content 역할 */\r\n  flex-grow: 1;\r\n  display: flex; /* SplitPane이 이 flex 컨테이너를 채우도록 */\r\n  flex-direction: column; /* 내부 FileTabs와 SplitPane이 세로로 배치되도록 */\r\n  overflow: hidden; /* SplitPane이 스크롤을 관리하도록 */\r\n  /* clip — hidden 은 **코드로는 스크롤된다.** 하위 화면의 scrollIntoView 가 이 칸을 밀어 올려 편집기 툴바 줄이\r\n     화면 위로 사라졌다(2026-10-05). clip 은 스크롤 칸이 아니라 어떤 코드도 밀 수 없다(미지원이면 위 hidden). */\r\n  overflow: clip;\r\n  min-width: 0;     /* flex-row 부모(.content-area)의 자식이 콘텐츠(테이블) 폭만큼 늘어나는 것을 방지 — 결과 그리드의 overflow:auto 가로 스크롤 동작 보장. */\r\n  /* padding: 0; */ /* 내부 컴포넌트가 전체 영역을 사용하도록 패딩 조정 */\r\n}\r\n\r\n/* FileTabs를 위한 컨테이너 스타일 추가 */\r\n.file-tabs-container {\r\n  flex-shrink: 0; /* 탭 영역은 줄어들지 않음 */\r\n  /* padding: 5px 10px; */ /* 탭 내부 패딩은 FileTabs.module.css에서 관리 */\r\n  /* border-bottom: 1px solid #ccc; */ /* 탭과 에디터 구분선, FileTabs.module.css에 포함하는게 나을수도 있음 */\r\n  background-color: #f0f0f0; /* 탭 영역 배경색 구분 (선택적) */\r\n  /* min-height: 40px; */ /* 탭 높이 확보, FileTabs.module.css에서 구체적 높이 설정 권장 */\r\n  z-index: 10; /* SplitPane 구분선(z-index:5) 보다 높게 설정하여 가려지지 않도록 */\r\n  position: relative; /* z-index 적용을 위해 */\r\n}\r\n\r\n.split-pane-container { /* SplitPane을 감싸는 컨테이너 */\r\n  flex-grow: 1;\r\n  display: flex; /* 내부 SplitPane이 100% 크기를 가지도록 */\r\n  min-height: 0; /* flex 아이템이 수축할 수 있도록 */\r\n  min-width: 0;  /* flex-column 부모(.main-work-area)에서 자식이 콘텐츠 폭만큼 늘어나는 것을 방지. */\r\n  position: relative; /* Resizer가 올바르게 동작하도록 */\r\n}\r\n\r\n/* ───── 커스텀 툴팁 (portal 방식) ─────\r\n   App.js 에서 [title] → [data-tooltip] 전역 이전 + JS 가 document.body 에 .app-portal-tooltip 띄움.\r\n   부모의 overflow:hidden / clipping context 영향 안 받음 (그리드 셀, CM gutter marker 등 안전).\r\n   위치는 JS 가 계산 — left/top 인라인 스타일로 설정. 좌/우/하단 뷰포트 jam 시 clamp/flip. */\r\n.app-portal-tooltip {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  background: rgba(40, 40, 40, 0.95);\r\n  color: #f5f5f5;\r\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n  font-size: 11px;\r\n  font-weight: normal;\r\n  line-height: 1.35;\r\n  padding: 4px 8px;\r\n  border-radius: 3px;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  max-width: 360px;\r\n  width: max-content;\r\n  pointer-events: none;\r\n  z-index: 10000;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 80ms ease-out;\r\n}\r\n.app-portal-tooltip.visible {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n[data-theme=\"dark\"] .app-portal-tooltip {\r\n  background: #2d2d3a;\r\n  color: #cdd6f4;\r\n  border: 1px solid #585b70;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .app-portal-tooltip { transition: none; }\r\n}\r\n\r\n/* SplitPane 스타일 커스터마이징 — 두께 축소 + 가운데 grip 으로 드래그 가능 명시. */\r\n.Resizer.horizontal {\r\n  height: 5px !important;\r\n  background: #eee !important;\r\n  border-top: 1px solid #ccc !important;\r\n  border-bottom: 1px solid #ccc !important;\r\n  cursor: ns-resize !important;\r\n  margin: -1px 0;\r\n  z-index: 5;\r\n  position: relative;\r\n}\r\n.Resizer.horizontal::after {\r\n  /* 가운데에 가로 점 3개 grip — 드래그 핸들임을 시각적으로 표시. */\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 30px;\r\n  height: 3px;\r\n  background: radial-gradient(circle, #999 1px, transparent 1.5px) 0 50%/8px 100% repeat-x;\r\n  pointer-events: none;\r\n}\r\n.Resizer.horizontal:hover {\r\n  background: #ddd !important;\r\n}\r\n.Resizer.horizontal:hover::after {\r\n  background: radial-gradient(circle, #555 1.5px, transparent 2px) 0 50%/8px 100% repeat-x;\r\n}\r\n[data-theme=\"dark\"] .Resizer.horizontal::after {\r\n  background: radial-gradient(circle, #aaa 1px, transparent 1.5px) 0 50%/8px 100% repeat-x;\r\n}\r\n[data-theme=\"dark\"] .Resizer.horizontal:hover::after {\r\n  background: radial-gradient(circle, #fff 1.5px, transparent 2px) 0 50%/8px 100% repeat-x;\r\n}\r\n\r\n/* 영역 접기/펼치기 버튼 — 에디터 toolbar 에 배치. */\r\n.split-collapse-btn {\r\n  background: transparent;\r\n  border: 1px solid var(--color-border, #d1d5db);\r\n  border-radius: 3px;\r\n  padding: 4px 5px;\r\n  line-height: 1; /* 줄 상자를 글자 높이에 맞춰 레이블이 아래로 치우치지 않게 — 줄인 만큼 위아래 여백을 늘려 높이는 그대로 */\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  color: var(--color-text-secondary, #555);\r\n  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;\r\n}\r\n.split-collapse-btn:hover {\r\n  background: var(--color-hover, #f3f4f6);\r\n  color: var(--color-text, #1f2937);\r\n  border-color: var(--color-border, #9ca3af);\r\n}\r\n.split-collapse-btn.active {\r\n  background: rgba(59, 130, 246, 0.12);\r\n  color: #1d4ed8;\r\n  border-color: rgba(29, 78, 216, 0.5);\r\n}\r\n[data-theme=\"dark\"] .split-collapse-btn {\r\n  border-color: var(--color-border);\r\n  color: var(--color-text-secondary);\r\n}\r\n[data-theme=\"dark\"] .split-collapse-btn:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .split-collapse-btn.active {\r\n  background: rgba(108, 182, 255, 0.18);\r\n  color: #8fc7ff;\r\n  border-color: rgba(108, 182, 255, 0.5);\r\n}\r\n\r\n/* SQLEditor와 ResultGrid를 감싸는 Pane 내부의 div 스타일 */\r\n.sql-editor-pane {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n  min-height: 0;\r\n  background: var(--color-bg);\r\n}\r\n\r\n.sql-editor-inner-container { /* SQLEditor.js 내부의 최상위 div.\r\n   display:flex 가 반드시 있어야 한다. 자식(에디터+미니맵 래퍼)이 flex:1 로 높이를 받는데,\r\n   이게 block 이면 flex 가 무시돼 자식이 \"문서 전체 높이\" 로 늘어난다.\r\n   실측(60줄 문서): block 이면 래퍼 7,933px · 내부 스크롤 불가 · 커서가 클리핑 영역 밖\r\n   (1197px)으로 나가 보이지 않았다. flex 를 주면 422px · 스크롤 정상 · 커서 보임.\r\n   문서가 크면 미니맵 canvas 높이가 20만 px 를 넘어 브라우저 한계로 렌더도 깨졌다.\r\n   ⚠️ 예전 주석은 이 증상(\"커서가 맨 아래에서 깜빡이고 타이핑이 안 보임\")의 원인을\r\n   display:flex 로 지목했으나 인과가 반대였다 — block 이 원인이다. 되돌리지 말 것. */\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  overflow: hidden;\r\n  min-height: 0;\r\n}\r\n\r\n.codemirror-editor-area { /* SQLEditor.js 내부의 CodeMirror 편집기 영역 */\r\n  flex-grow: 1;\r\n  flex-shrink: 1; /* 필요시 수축 허용 */\r\n  /* 높이는 SQLEditor.js 내부에서 flex-grow로 이미 설정되어 있음 */\r\n  display: flex; /* 추가: 내부 cm-editor가 높이를 100% 차지하도록 */\r\n  flex-direction: column; /* 추가 */\r\n  min-height: 0; /* flex 컨테이너에서 수축 허용 */\r\n  overflow: hidden; /* 자식 요소의 스크롤이 관리하도록 */\r\n}\r\n\r\n/* CodeMirror 전체 배경 및 높이 일관성 적용 */\r\n.codemirror-editor-area .cm-editor {\r\n  background-color: #ffffff; /* 밝은 배경색으로 변경 */\r\n  height: 100% !important; /* 부모 높이를 완전히 채우도록 */\r\n  color: #333333; /* 어두운 텍스트 색상으로 변경 */\r\n  font-size: var(--font-size-mono);\r\n  /* 자체 테두리를 그리지 않는다 — 에디터를 둘러싼 네 변에 이미 다른 선이 있어서\r\n     (왼쪽 .schema-explorer-area 의 border-right, 위 .file-tabs-container 의\r\n     border-bottom, 아래 .Resizer.horizontal 의 border-top) 여기서 또 그으면\r\n     그 변만 2px 로 보인다. PL/SQL 모달처럼 테두리가 필요한 곳은 감싸는 wrap 이\r\n     긋는다 (.plsqled-editor-wrap / .plsqled-testcall-editor-wrap). */\r\n  flex-grow: 1; /* flex 컨테이너에서 남은 공간 차지 */\r\n  flex-shrink: 1; /* 필요시 수축 허용 */\r\n  min-height: 200px; /* 최소 높이 보장 */\r\n}\r\n\r\n.codemirror-editor-area .cm-scroller {\r\n  /* 스크롤 영역 자체에는 별도 배경색을 지정하지 않아 cm-editor 배경색이 보이도록 함 */\r\n  overflow: auto !important; /* 세로 스크롤바 강제 표시 */\r\n  height: 100% !important;\r\n  max-height: 100% !important; /* 최대 높이 제한 */\r\n}\r\n\r\n/* CodeMirror content 영역 padding 조정을 제거하여 CodeMirror 네이티브 가상 스크롤 및 좌표 계산이 정상 작동하게 함 */\r\n/* CodeMirror 밝은 테마 추가 스타일 */\r\n.codemirror-editor-area .cm-editor.cm-focused {\r\n  /* 포커스 테두리를 그리지 않는다 — 메인 화면의 다른 영역(결과 그리드·탐색기)은\r\n     클릭해도 테두리가 바뀌지 않으므로 에디터만 파란 테두리를 그리면 어긋난다.\r\n     CodeMirror 기본 outline 도 여기서 함께 지운다. */\r\n  outline: none;\r\n}\r\n\r\n.codemirror-editor-area .cm-activeLine {\r\n  background-color: #f8f9fa; /* 활성 라인 배경색 */\r\n}\r\n\r\n.codemirror-editor-area .cm-activeLineGutter {\r\n  background-color: #e9ecef; /* 활성 라인 거터 배경색 */\r\n}\r\n\r\n.sql-editor-buttons {\r\n  flex-shrink: 0; /* 버튼 영역은 줄어들지 않음 */\r\n  padding-top: 10px;\r\n}\r\n\r\n.result-and-pagination-area {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  overflow: hidden;\r\n  background: var(--color-bg);\r\n}\r\n\r\n/* MainDisplayTabs가 이 영역 내에서 남은 공간을 차지하도록 App.js에서 MainDisplayTabs를 감싸는 div에 flex-grow:1을 주거나, MainDisplayTabs 컴포넌트 자체의 최상위 div에 스타일을 적용해야 할 수 있음. */\r\n/* 여기서는 result-and-pagination-area를 flex container로 만들고, MainDisplayTabs와 StatusLine이 그 자식으로 배치됨. */\r\n/* MainDisplayTabs 컴포넌트의 최상위 div가 .mainDisplayTabsContainer 이므로, 여기에 flex-grow:1 을 주면 됨. */\r\n\r\n/* Result Grid Styles for Sticky Header */\r\n.result-grid {\r\n  flex: 1 1 0;\r\n  min-height: 0;\r\n  min-width: 0;          /* flex 자식의 기본 min-width:auto(=min-content) 해제 — 안 그러면 가로 콘텐츠가 부모를 뚫고 나가 overflow:auto 가 무력화됨 → 가로 스크롤바 안 뜸. */\r\n  max-height: 100%;\r\n  overflow: auto;\r\n  /* 테두리 대신 **배경색**으로 경계를 보인다(2026-10-07) — 표 밖(마지막 열 오른쪽·마지막 행 아래)은 옅은 회색, 셀은 흰색.\r\n     테두리를 두면 탭 머리줄의 아래선과 겹쳐 2px 로 보였고, 표 바깥쪽 선은 표의 border-style:hidden 에 가려 셀 아래·오른쪽이 비어 보였다. */\r\n  border: none;\r\n  background: var(--rg-outside-bg, #f0f2f5);\r\n  position: relative;\r\n  margin-bottom: 10px; /* 페이지네이션과의 간격 */\r\n  /* 스크롤바 항상 표시 — Windows 11 / 최신 Chrome 의 overlay (auto-hide) 스크롤바 동작을\r\n     명시적 webkit 스타일링으로 override. firefox 도 scrollbar-color 로 가시성 보장. */\r\n  scrollbar-color: #888 #f0f0f0;\r\n  scrollbar-width: auto;\r\n}\r\n.result-grid::-webkit-scrollbar {\r\n  width: 14px;\r\n  height: 14px;\r\n  background: #f0f0f0;\r\n}\r\n.result-grid::-webkit-scrollbar-track {\r\n  background: #f0f0f0;\r\n}\r\n.result-grid::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border: 3px solid #f0f0f0;\r\n  border-radius: 7px;\r\n}\r\n.result-grid::-webkit-scrollbar-thumb:hover {\r\n  background: #666;\r\n}\r\n.result-grid::-webkit-scrollbar-corner {\r\n  background: #f0f0f0;\r\n}\r\n[data-theme=\"dark\"] .result-grid {\r\n  scrollbar-color: #666 #1e1e1e;\r\n}\r\n[data-theme=\"dark\"] .result-grid::-webkit-scrollbar,\r\n[data-theme=\"dark\"] .result-grid::-webkit-scrollbar-track,\r\n[data-theme=\"dark\"] .result-grid::-webkit-scrollbar-corner {\r\n  background: #1e1e1e;\r\n}\r\n[data-theme=\"dark\"] .result-grid::-webkit-scrollbar-thumb {\r\n  background: #555;\r\n  border-color: #1e1e1e;\r\n}\r\n[data-theme=\"dark\"] .result-grid::-webkit-scrollbar-thumb:hover {\r\n  background: #777;\r\n}\r\n\r\n.result-grid table {\r\n  /* width: 0 → 컬럼은 명시 cell width 그대로, redistribution 없음 (사용자 검증 OK).\r\n     테이블의 outer 측정 width 는 0 이지만 wrapper(.result-grid-table-wrap)가 JS 계산 polygonal 합계를\r\n     style.minWidth 로 강제 → 부모 overflow 검출에 사용됨. */\r\n  width: 0;\r\n  border-collapse: collapse;\r\n  table-layout: fixed;\r\n  font-size: var(--font-size-grid);\r\n  border-style: hidden;\r\n}\r\n/* table 을 감싸는 wrapper — JS 가 컬럼 합계를 minWidth 로 인라인 적용.\r\n   - block-level wrapper. CSS 로 width 강제 X. JSX 의 style.minWidth 가 단독 sizing source.\r\n   - 부모(.result-grid) 는 wrapper 의 minWidth 를 보고 overflow 감지 → 가로 스크롤바 표시.\r\n   - CSS 의 max-content 같은 intrinsic sizing 에 의존하지 않으므로 Chrome quirks 영향 X. */\r\n.result-grid-table-wrap {\r\n  display: inline-block;     /* 자식(table) 의 시각 폭으로 sizing + 부모 폭 stretch 거부 */\r\n  vertical-align: top;       /* inline-level baseline 빈 공간 제거 */\r\n  /* 인라인 style.minWidth 가 JS 가 계산한 컬럼 합계를 강제 → 부모 overflow:auto 가 정확히 검출 */\r\n\r\n  /* 가로 스크롤바 자리를 비워 둔다. 스크롤바는 스크롤 영역 **안쪽** 아래를 차지하므로,\r\n     내용 높이가 딱 맞으면 **마지막 행이 스크롤바에 가려** 끝까지 내려도 보이지 않는다.\r\n     가로로 넘치는 결과(예: dbms_xplan 출력)에서만 나타나서 \"일반 조회는 안 가리는데\r\n     이것만 가린다\" 로 보였다(신고 2026-09-18). 스크롤바 높이(14px)만큼 여유를 준다. */\r\n  padding-bottom: 14px;\r\n}\r\n\r\n.result-grid th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: var(--color-grid-header);\r\n  color: var(--color-text);\r\n  font-weight: 600;\r\n  /* 휠 확대/축소를 따른다(2026-10-07) — UI 고정 크기이던 때는 본문만 커지고 머리글은 그대로였다 */\r\n  font-size: calc(var(--font-size-grid, 12px) - 1px);\r\n  font-family: var(--font-ui);\r\n  user-select: none;\r\n  border: 1px solid var(--color-grid-border);\r\n  padding: 4px 10px;       /* 세로 padding 축소 — 더 컴팩트한 헤더 */\r\n  text-align: left; /* 왼쪽 정렬 */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.result-grid td {\r\n  /* 선은 옅게 — 세로선은 가로선보다 더(2026-10-07, 「라인은 슬림하게」). 값이 먼저 보여야 한다 */\r\n  border: 1px solid #eceef1;\r\n  border-left-color: #f3f4f6;\r\n  border-right-color: #f3f4f6;\r\n  padding: 3px 10px;       /* 세로 padding 축소 — 더 많은 행 표시 (이전 10px → 3px) */\r\n  text-align: left; /* 왼쪽 정렬 */\r\n  /* `pre` — 연속 공백을 **보존**한다. `nowrap` 은 줄바꿈만 막고 공백은 HTML 규칙대로 접어서,\r\n     `dbms_xplan.display_cursor` 같은 자리 맞춤 출력의 들여쓰기가 통째로 사라졌다(실측 2026-09-18).\r\n     평범한 값에는 `nowrap` 과 차이가 없다. */\r\n  white-space: pre;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* 결과 영역 위 도구줄(기본·수직 분할·창 분리 세 곳 공통).\r\n   폭이 모자라면 **항목째 다음 줄로** 넘긴다 — 줄바꿈 없이 두면 체크박스 라벨이 줄어들며 한글이 한 글자씩\r\n   세로로 꺾였다(「실/행/계/획/보/기」, 신고 2026-10-06). 라벨·버튼은 그 자체로는 꺾이지 않는다. */\r\n.result-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  /* 왼쪽부터 채운다 — 오른쪽 정렬로 두면 넘친 줄이 왼쪽 끝에서 잘린다. 넓을 때 나머지가 오른쪽에 붙는 것은\r\n     첫 묶음(탭 필터)의 margin-right: auto 가 한다 */\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 4px 8px;\r\n  padding: 4px 6px;\r\n  flex-shrink: 0;\r\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n}\r\n.result-toolbar > div { flex-wrap: wrap; }\r\n.result-toolbar .compact-view-toggle,\r\n.result-toolbar .detach-inline-btn { white-space: nowrap; flex-shrink: 0; }\r\n\r\n/* 결과탭 툴바의 \"압축 보기\" 토글 — light/dark theme 대응. */\r\n.compact-view-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  color: var(--color-text, #1f2937);\r\n}\r\n.compact-view-toggle input[type=\"checkbox\"] {\r\n  margin: 0;\r\n  accent-color: #3b82f6;\r\n}\r\n[data-theme=\"dark\"] .compact-view-toggle {\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .compact-view-toggle input[type=\"checkbox\"] {\r\n  color-scheme: dark;\r\n  accent-color: #6cb6ff;\r\n}\r\n\r\n/* 체크박스 레이블 마우스 올림 — 체크박스만이 아니라 **아이콘·레이블까지 한 덩어리로** 강조한다(사용자 요청 2026-10-05).\r\n   체크박스가 여럿 늘어서면 체크박스만 바뀌어서는 어느 레이블의 것인지 헷갈린다. 편집기 쪽(.editor-option-label)과\r\n   결과 쪽(.compact-view-toggle)이 같은 모양이다. 강조색은 툴바 버튼(.detach-inline-btn:hover)과 같다. */\r\n.editor-option-label,\r\n.compact-view-toggle {\r\n  padding: 1px 4px;\r\n  border-radius: 3px;\r\n  transition: color 150ms ease, background-color 150ms ease;\r\n}\r\n.editor-option-label:hover,\r\n.compact-view-toggle:hover {\r\n  color: #007bff;\r\n  background-color: rgba(0, 123, 255, 0.08);\r\n}\r\n[data-theme=\"dark\"] .editor-option-label:hover,\r\n[data-theme=\"dark\"] .compact-view-toggle:hover {\r\n  color: #6cb6ff !important;   /* 다크의 기본 글자색이 !important 라 같이 준다 */\r\n  background-color: var(--color-hover);\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .editor-option-label,\r\n  .compact-view-toggle { transition: none; }\r\n}\r\n\r\n/* 그리드 셀 — 항상 cursor: pointer (잘려있으면 클릭 시 popup, 아니면 무동작). 링크 스타일은 적용하지 않음. */\r\n.result-grid-cell {\r\n  cursor: pointer;\r\n}\r\n\r\n/* NULL 셀 — 실제 빈 문자열과 구분되도록 흐린 이탤릭. 표시 텍스트는 설정에서 변경 가능. */\r\n.result-grid-cell.is-null {\r\n  color: var(--color-text-muted, #9ca3af);\r\n  font-style: italic;\r\n}\r\n\r\n/* 잘린 셀 표시 — 우측 끝에 큰 ⋯ 오버레이. 클릭 자체는 셀(span) 의 onClick 이 받음 (pointer-events: none). */\r\n.result-grid td.truncated {\r\n  position: relative;\r\n  text-overflow: clip; /* 브라우저 기본 작은 \"...\" 숨김 — 아래 ::after 가 대체 */\r\n}\r\n/* 잘림 표시는 **눈에 띄지 않아야** 한다 — 값이 아니라 값이 더 있다는 귀띔이다.\r\n   예전에는 18px·굵기 800·파란색이라 데이터보다 강해서, 화면이 파란 점으로 얼룩져 보였다. */\r\n.result-grid td.truncated::after {\r\n  content: '…';\r\n  position: absolute;\r\n  right: 1px;\r\n  top: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 14px;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 1;\r\n  color: var(--color-text-muted, #9ca3af);\r\n  background: linear-gradient(to right, transparent 0, var(--color-bg, #fff) 6px);\r\n  padding-left: 6px;\r\n  pointer-events: none;\r\n}\r\n[data-theme=\"dark\"] .result-grid td.truncated::after {\r\n  color: var(--color-text-muted);\r\n  background: linear-gradient(to right, transparent 0, var(--color-bg) 6px);\r\n}\r\n/* 압축 모드에선 살짝 작게 */\r\n.result-grid-compact td.truncated::after {\r\n  font-size: 11px;\r\n  width: 12px;\r\n}\r\n\r\n/* Recharts Tooltip 다크모드 강제 오버라이드 (인라인 스타일 무시 방지) */\r\n[data-theme=\"dark\"] .recharts-default-tooltip {\r\n  background-color: #1f2937 !important;\r\n  border-color: #4b5563 !important;\r\n}\r\n\r\n\r\n/* 압축 보기 — 셀 여백/줄높이/폰트 모두 최소화. 한 화면에 더 많은 행/열 표시. */\r\n.result-grid-compact th,\r\n.result-grid-compact td {\r\n  padding: 1px 4px;\r\n  line-height: 1.15;\r\n  min-width: 40px;\r\n  font-size: calc(var(--font-size-grid, 13px) - 1px);\r\n}\r\n.result-grid-compact td:first-child div {\r\n  padding: 1px 2px;\r\n}\r\n.result-grid-compact .column-header-content {\r\n  padding: 0;\r\n}\r\n/* 헤더의 컬럼 코멘트 부제 (작은 회색 글자) 도 압축 모드에선 한 줄로 더 작게. */\r\n.result-grid-compact th span span {\r\n  font-size: 9px !important;\r\n  margin-top: 0 !important;\r\n  line-height: 1.1 !important;\r\n}\r\n\r\n.loading-more-indicator {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    text-align: center;\r\n    padding: 15px;\r\n    color: #666;\r\n    background-color: #f8f9fa;\r\n    border-top: 1px solid #e9ecef;\r\n    font-size: var(--font-size-ui);\r\n}\r\n\r\n.loading-spinner {\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 2px solid #e9ecef;\r\n    border-top: 2px solid #007bff;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0; \r\n  gap: 10px;\r\n}\r\n\r\n.side-panel-area {\r\n  /* 줄어들 수 있게 둔다(flex-shrink 1). 못 줄면 창이 좁을 때(125% 배율 등) 이 900px 과 AI 에이전트\r\n     520px 이 넘쳐, **맨 오른쪽의 AI 에이전트가 화면 밖으로 잘렸다.** 안쪽은 폭이 고정이라\r\n     좁아지면 이 패널의 오른쪽이 잘릴 뿐 글자가 다시 배치되지 않는다. */\r\n  /* 실행이력만 여기 남았다(2026-10-19) — 폭은 예전(900px)의 절반. 편집기를 분리했을 때 오는 실행계획 분석·챌린지는 .wide 로 예전 폭 */\r\n  flex: 0 1 450px;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-left: 1px solid #ccc;\r\n  /* 스르르 접히고 펼쳐진다. 예전에는 이 규칙이 있어도 소용없었다 — 패널을 조건부로 렌더해\r\n     DOM 에서 통째로 사라졌기 때문이다. 이제 늘 그려 두고 폭만 바꾼다. */\r\n  transition: flex-basis 260ms ease, padding 260ms ease, opacity 200ms ease;\r\n  overflow: hidden;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  position: relative;\r\n  z-index: 20;\r\n}\r\n\r\n.side-panel-area.wide { flex-basis: 900px; }\r\n/* 데이터 분석도 같은 틀 — 패널 자체의 폭(420)·왼쪽 선을 풀어 실행이력과 같은 폭으로 채운다 */\r\n.side-panel-area.wide .side-panel-inner { min-width: 880px; }\r\n\r\n.side-panel-area.closed {\r\n  flex-basis: 0;\r\n  padding: 0;\r\n  border-left: none;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* 안쪽은 **폭이 고정**이다. 접힐 때 내용까지 좁아지면 글자가 다시 배치되며 출렁인다 —\r\n   바깥이 좁아지고 안쪽은 그대로 잘려 나가야 미닫이처럼 보인다. (900 - 좌우 padding 20) */\r\n.side-panel-inner {\r\n  /* 열려 있을 때는 **딱 맞게**(100%), 접히는 동안만 줄지 않는다(min-width).\r\n     예전에는 880px 로 못 박아서 열린 폭과 어긋나 오른쪽이 살짝 넘쳤다. */\r\n  width: 100%;\r\n  min-width: 430px;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .side-panel-area { transition: none; }\r\n}\r\n\r\n.sql-history {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column; \r\n}\r\n\r\n.App {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 20px;\r\n  font-size: 10px;\r\n  font-family: 'Arial', sans-serif;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.username-input, .owner-select {\r\n  padding: 6px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1em;\r\n}\r\n\r\n.username-label, .owner-select-label {\r\n  font-weight: bold;\r\n  margin-right: 0;\r\n}\r\n\r\n.clear-history-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.clear-history-button {\r\n  background-color: #f44336;\r\n  color: white;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 10px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* 헤더 영역 스타일 */\r\n/* 제목을 뺀 뒤로는 전체 삭제 버튼만 담는 줄이다. 버튼이 없으면 자리도 차지하지 않는다. */\r\n.history-header-section {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  min-height: 0;\r\n}\r\n.history-header-section:not(:empty) { margin-bottom: 6px; }\r\n\r\n.history-header-section .section-title {\r\n  margin: 0;\r\n  flex-grow: 1;\r\n}\r\n\r\n/* 헤더의 전체 삭제 버튼 */\r\n.clear-history-button-header {\r\n  background-color: #f44336;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 12px;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.clear-history-button-header:hover {\r\n  background-color: #da190b;\r\n}\r\n\r\n/* 개별 삭제 버튼 */\r\n.delete-history-item-button {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s;\r\n  line-height: 1;\r\n}\r\n\r\n.delete-history-item-button:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n.history-list {\r\n  flex: 1 1 auto;\r\n  overflow-y: auto;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n/* 새로운 히스토리 테이블 스타일 */\r\n.history-table {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.history-header {\r\n  display: flex;\r\n  background-color: #f8f9fa;\r\n  border-bottom: 2px solid #ddd;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n  color: #495057;\r\n  /* 스크롤바 너비만큼 여백 추가 */\r\n  padding-right: 0;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  scrollbar-gutter: stable;\r\n}\r\n\r\n.history-header > div {\r\n  padding: 8px 6px;\r\n  border-right: 1px solid #ddd;\r\n  text-align: center;\r\n}\r\n\r\n.history-header > div:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.history-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 400px;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.history-row {\r\n  display: flex;\r\n  border-bottom: 1px solid #eee;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.history-row:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.history-row.success {\r\n  box-shadow: inset 3px 0 0 #28a745;\r\n}\r\n\r\n.history-row.error {\r\n  box-shadow: inset 3px 0 0 #dc3545;\r\n}\r\n\r\n.history-row > div {\r\n  padding: 6px 6px;\r\n  border-right: 1px solid #eee;\r\n  font-size: 11px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.history-row > div:last-child {\r\n  border-right: none;\r\n}\r\n\r\n/* 컬럼 너비 설정 */\r\n.history-col-datetime {\r\n  flex: 0 0 120px;\r\n  min-width: 120px;\r\n}\r\n\r\n.history-col-status {\r\n  flex: 0 0 50px;\r\n  min-width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.history-col-query {\r\n  flex: 1;\r\n  min-width: 200px;\r\n  text-align: left;\r\n}\r\n\r\n.history-col-count {\r\n  flex: 0 0 80px;\r\n  min-width: 80px;\r\n  text-align: right;\r\n}\r\n\r\n.history-col-time {\r\n  flex: 0 0 70px;\r\n  min-width: 70px;\r\n  text-align: right;\r\n}\r\n\r\n.history-col-delete {\r\n  flex: 0 0 50px;\r\n  min-width: 50px;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* 상태 배지 */\r\n.status-badge {\r\n  padding: 2px 6px;\r\n  border-radius: 12px;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.status-badge.success {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.error {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n/* 더보기 표시 */\r\n.more-indicator {\r\n  color: #007bff;\r\n  font-size: 10px;\r\n  font-style: italic;\r\n}\r\n\r\n.error-text {\r\n  color: #6c757d;\r\n  font-style: italic;\r\n}\r\n\r\n/* 히스토리 없음 메시지 */\r\n.no-history {\r\n  text-align: center;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  padding: 32px 16px;\r\n  border: 1px dashed #ddd;\r\n  border-radius: 4px;\r\n  background-color: #f8f9fa;\r\n  /* 조상이 어떤 폭이든 **넘치지 않는다.** padding·border 를 폭 안에 넣고(border-box)\r\n     좌우 여백을 줘 패널 가장자리에 딱 붙지 않게 한다 — 붙으면 넘친 것처럼 보인다. */\r\n  box-sizing: border-box;\r\n  max-width: 100%;\r\n  margin: 4px 8px;\r\n}\r\n\r\n/* 패널 안의 절 제목 — **한 가지 모양만** 쓴다.\r\n   예전에는 같은 클래스가 자리마다 다르게 보였다: 이력에서는 1.2em 밑줄 제목,\r\n   튜닝의 헤더 막대 안에서는 13px 인데 밑줄이 또 그어져 이중선이 됐다.\r\n   밑줄이 필요한 곳은 감싸는 쪽이 긋는다(.history-header-section). */\r\n.section-title {\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: var(--font-size-ui, 12px);\r\n  font-weight: 600;\r\n  color: var(--color-text-secondary, #4b5563);\r\n}\r\n\r\n.no-results {\r\n  color: #999;\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  font-weight: bold;\r\n}\r\n\r\n.column-header-content {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  padding-right: 8px; /* 리사이저 공간 확보 */\r\n}\r\n\r\n.result-grid th .column-resizer {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 8px;\r\n  height: 100%;\r\n  cursor: col-resize;\r\n  background: transparent;\r\n  border-right: 2px solid transparent;\r\n  z-index: 15; /* sticky header보다 높게 설정 */\r\n  user-select: none;\r\n}\r\n\r\n.result-grid th .column-resizer:hover {\r\n  border-right-color: #007bff;\r\n  background-color: rgba(0, 123, 255, 0.1);\r\n}\r\n\r\n.result-grid th .column-resizer:active {\r\n  border-right-color: #0056b3;\r\n  background-color: rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n/* 리사이즈 중 오버레이 */\r\n.resize-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  cursor: col-resize;\r\n  z-index: 9999;\r\n  background: transparent;\r\n}\r\n\r\n/* 행 번호 컬럼 (첫 번째) — 헤더 # 와 동일하게 본문 숫자값도 왼쪽 정렬. */\r\n.result-grid td[data-type=\"__system__\"],\r\n.result-grid td[data-type=\"__system__\"] > * {\r\n  text-align: left;\r\n}\r\n\r\n/* 데이터 타입별 스타일 — **정렬만** 다르게 한다. 글꼴·굵기·색은 모든 데이터 셀이 같다(사용자 요청 2026-09-13).\r\n   예전엔 숫자·날짜·id 에 가는 'Courier New', 이름에 \"id\" 가 든 컬럼에 회색(#666, 다크모드에서도 이겼다),\r\n   참/거짓에 굵게를 줘서 같은 행 안에서 값마다 진하게/흐리게 보였다.\r\n   자료형 추정(ResultGrid.detectDataType)은 표본 10행으로 하는 짐작이라 모양까지 바꾸면 틀릴 때 더 눈에 띈다.\r\n   NULL(흐린 이탤릭)과 행 번호 열(__system__)은 \"값 없음\"·\"데이터 아님\" 표시라 따로 둔다. */\r\n.result-grid td[data-type=\"number\"] {\r\n  text-align: right;\r\n  font-variant-numeric: tabular-nums; /* 같은 글꼴에서 자릿수 폭만 맞춘다 — 굵기·색은 그대로 */\r\n}\r\n\r\n.result-grid td[data-type=\"boolean\"] {\r\n  text-align: center;\r\n}\r\n\r\n/* 로우 순번 컬럼 전용 스타일 */\r\n.result-grid th:first-child,\r\n.result-grid td:first-child {\r\n  position: sticky;\r\n  left: 0; /* 좌우 스크롤에 고정 */\r\n  background-color: #fafafa !important;\r\n  min-width: var(--rg-rownum-w, 30px) !important;\r\n  max-width: var(--rg-rownum-w, 30px) !important;\r\n  width: var(--rg-rownum-w, 30px) !important;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  user-select: none;\r\n  cursor: default;\r\n}\r\n\r\n/* 로우 순번 헤더 - 상하/좌우 스크롤 모두에 고정 */\r\n.result-grid th:first-child {\r\n  top: 0;\r\n  z-index: 25;\r\n  background-color: #f0f0f0 !important;\r\n  color: #666;\r\n  font-size: calc(var(--font-size-grid, 12px) - 1px);\r\n  padding: 4px 2px !important;\r\n  text-align: center !important;\r\n}\r\n/* 「#」 가운데 — 머리글 내용 칸은 리사이저 자리(오른쪽 8px)를 비우는 flex 라 왼쪽으로 치우쳐 있었다 */\r\n.result-grid th:first-child .column-header-content {\r\n  justify-content: center;\r\n  padding-right: 0;\r\n}\r\n\r\n.result-grid th:first-child span {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n/* 로우 순번 데이터 셀 */\r\n.result-grid td:first-child {\r\n  z-index: 20; /* 일반 셀보다 높게 설정 */\r\n  color: #999;\r\n  font-size: calc(var(--font-size-grid, 12px) - 1px);\r\n  padding: 0 !important;\r\n}\r\n\r\n/* 세로 padding 은 데이터 셀과 같게 — 8px 이던 시절에는 순번 칸이 행 높이를 정해서(약 31px)\r\n   「압축」을 켜도 행이 그대로였다(신고 2026-10-01). */\r\n.result-grid td:first-child div {\r\n  padding: 3px 2px;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* 로우 순번 컬럼의 resizer는 숨김 */\r\n.result-grid th:first-child .column-resizer {\r\n  display: none !important;\r\n}\r\n\r\n/* SQL History - 선택된 행 스타일 */\r\n.history-row.selected {\r\n  background-color: #e3f2fd !important;\r\n  border-left: 3px solid #2196f3 !important;\r\n}\r\n\r\n/* 선택된 쿼리 상세 표시 섹션 */\r\n.selected-query-section {\r\n  margin-top: 15px;\r\n  padding: 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.selected-query-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.selected-query-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.close-query-button {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  color: #999;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 2px;\r\n}\r\n\r\n.close-query-button:hover {\r\n  background-color: #f0f0f0;\r\n  color: #666;\r\n}\r\n\r\n/* 쿼리 메타 정보 */\r\n.selected-query-info {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.query-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  align-items: center;\r\n  font-size: 12px;\r\n}\r\n\r\n.query-time {\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.query-status.success {\r\n  color: #28a745;\r\n  font-weight: 600;\r\n}\r\n\r\n.query-status.error {\r\n  color: #dc3545;\r\n  font-weight: 600;\r\n}\r\n\r\n.query-count {\r\n  color: #17a2b8;\r\n  font-weight: 500;\r\n}\r\n\r\n.query-exec-time {\r\n  color: #6c757d;\r\n  font-style: italic;\r\n}\r\n\r\n.query-error {\r\n  margin-top: 8px;\r\n  padding: 8px 10px;\r\n  background-color: #f8d7da;\r\n  border: 1px solid #f5c6cb;\r\n  border-radius: 3px;\r\n  color: #721c24;\r\n  font-size: 12px;\r\n}\r\n\r\n.query-error strong {\r\n  font-weight: 600;\r\n}\r\n\r\n/* SQL 쿼리 텍스트 표시 영역 */\r\n.selected-query-content {\r\n  margin: 10px 0;\r\n}\r\n\r\n.sql-query-text {\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 3px;\r\n  padding: 12px;\r\n  margin: 0;\r\n  font-family: 'Courier New', Courier, monospace;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  color: #333;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* 액션 버튼 영역 */\r\n.selected-query-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid #eee;\r\n}\r\n\r\n.copy-to-editor-button {\r\n  background-color: #007bff;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 12px;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.copy-to-editor-button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* 바인드 변수 관련 스타일 */\r\n.bind-variables-indicator {\r\n  color: #6f42c1;\r\n  font-weight: 500;\r\n  font-size: 11px;\r\n}\r\n\r\n.bind-variables-info {\r\n  margin-top: 8px;\r\n  padding: 8px 10px;\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 3px;\r\n  font-size: 12px;\r\n}\r\n\r\n.bind-variables-info strong {\r\n  color: #495057;\r\n  font-weight: 600;\r\n  margin-bottom: 5px;\r\n  display: block;\r\n}\r\n\r\n.bind-variables-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.bind-variable-item {\r\n  background-color: #e9ecef;\r\n  padding: 2px 6px;\r\n  border-radius: 2px;\r\n  font-size: 11px;\r\n  color: #495057;\r\n}\r\n\r\n.bind-variable-item code {\r\n  background-color: transparent;\r\n  color: inherit;\r\n  font-size: inherit;\r\n}\r\n\r\n/* 쿼리 섹션 구분 */\r\n.query-section {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.query-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.query-section-title {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  margin-bottom: 5px;\r\n  padding: 3px 0;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.sql-query-text.original {\r\n  border-left: 3px solid #6f42c1;\r\n  background-color: #faf9ff;\r\n}\r\n\r\n.sql-query-text.executed {\r\n  border-left: 3px solid #17a2b8;\r\n  background-color: #f8fdff;\r\n}\r\n\r\n/* Row Number Grid Styles */\r\n.result-grid td[data-type=\"__system__\"] {\r\n  background-color: #f8f9fa;\r\n  color: #6c757d;\r\n  font-weight: 500;\r\n  text-align: center;\r\n}\r\n\r\n[data-theme=\"dark\"] .result-grid td[data-type=\"__system__\"] {\r\n  background-color: var(--color-bg-secondary);\r\n  color: var(--color-text-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .result-grid th:first-child,\r\n[data-theme=\"dark\"] .result-grid td:first-child {\r\n  background-color: var(--color-bg-secondary) !important;\r\n  color: var(--color-text-muted) !important;\r\n  border-color: var(--color-grid-border) !important;\r\n}\r\n[data-theme=\"dark\"] .result-grid th:first-child {\r\n  background-color: var(--color-bg-tertiary) !important;\r\n}\r\n\r\n/* SQL 실행이력 다크모드 */\r\n[data-theme=\"dark\"] .sql-history { color: var(--color-text); }\r\n[data-theme=\"dark\"] .history-header { background: var(--color-bg-tertiary) !important; border-color: var(--color-border) !important; border-bottom: 2px solid var(--color-border) !important; }\r\n[data-theme=\"dark\"] .history-header > div { border-color: var(--color-border) !important; color: var(--color-text-muted) !important; }\r\n[data-theme=\"dark\"] .status-badge.success { background: rgba(46,125,50,0.2) !important; color: #4caf50 !important; }\r\n[data-theme=\"dark\"] .status-badge.error { background: rgba(198,40,40,0.2) !important; color: #ef5350 !important; }\r\n[data-theme=\"dark\"] .history-body { color: var(--color-text); }\r\n[data-theme=\"dark\"] .history-row { border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .history-row:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .history-row.selected { background-color: rgba(59, 130, 246, 0.15) !important; border-left-color: #3b82f6 !important; }\r\n[data-theme=\"dark\"] .history-row > div { border-color: var(--color-border); color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .history-row > .history-col-query { color: var(--color-text); }\r\n[data-theme=\"dark\"] .more-indicator { color: #60a5fa; }\r\n[data-theme=\"dark\"] .history-row.success { box-shadow: inset 3px 0 0 #2e7d32; }\r\n[data-theme=\"dark\"] .history-row.error { box-shadow: inset 3px 0 0 #c62828; }\r\n[data-theme=\"dark\"] .history-row.success .history-col-status { color: #4caf50; }\r\n[data-theme=\"dark\"] .history-row.error .history-col-status { color: #ef5350; }\r\n[data-theme=\"dark\"] .history-header-section { color: var(--color-text); border-color: var(--color-border); }\r\n/* 밑줄은 이제 감싸는 쪽(.history-header-section)이 긋는다 — 아래 규칙이 그것을 바꾼다 */\r\n[data-theme=\"dark\"] .history-header-section .section-title { color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .delete-history-item-button { background: #555; color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .delete-history-item-button:hover { background: #c62828; color: #fff; }\r\n/* 글자색만 바꾸면 배경(#f8f9fa)과 점선 테두리(#ddd)가 밝은 값 그대로 남아\r\n   어두운 화면에 흰 상자가 뜬다 — 세 가지를 함께 바꾼다. */\r\n[data-theme=\"dark\"] .no-history {\r\n  color: var(--color-text-muted);\r\n  background-color: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n/* 같은 화면(이력 패널)의 바인드 변수 안내 — 다크 규칙이 아예 없어 밝은 상자로 남아 있었다 */\r\n/* 결과 그리드의 로딩 링 — 밝은 회색(#e9ecef) 궤도가 어두운 배경에서 도드라진다 */\r\n[data-theme=\"dark\"] .loading-spinner { border-color: var(--color-border); border-top-color: var(--color-accent-fg); }\r\n[data-theme=\"dark\"] .bind-variables-info {\r\n  background-color: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .bind-variables-info strong { color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .bind-variable-item {\r\n  background-color: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .selected-query-section { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .selected-query-header { border-bottom-color: var(--color-border); }\r\n[data-theme=\"dark\"] .selected-query-header h3 { color: var(--color-text); }\r\n[data-theme=\"dark\"] .close-query-button { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .close-query-button:hover { background-color: var(--color-hover); color: var(--color-text); }\r\n[data-theme=\"dark\"] .query-time { color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .query-exec-time { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .query-error { background-color: rgba(220, 53, 69, 0.1); border-color: rgba(220, 53, 69, 0.3); color: #ff6b6b; }\r\n[data-theme=\"dark\"] .selected-query-actions { border-top-color: var(--color-border); }\r\n[data-theme=\"dark\"] .query-section-title { color: var(--color-text-secondary); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .sql-query-text { background: var(--color-bg); border-color: var(--color-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .sql-query-text.original { background: rgba(111,66,193,0.1); border-left-color: #9b59b6; }\r\n[data-theme=\"dark\"] .sql-query-text.executed { background: rgba(23,162,184,0.1); border-left-color: #17a2b8; }\r\n[data-theme=\"dark\"] .copy-to-editor-button { background: var(--color-btn-bg); color: var(--color-text); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .copy-to-editor-button:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .clear-history-button-header { background: #c62828; }\r\n[data-theme=\"dark\"] .delete-history-button { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .delete-history-button:hover { color: #ff6b6b; }\r\n/* 쿼리 챌린지 다크모드 — CSS 변수가 이미 적용된 컴포넌트 */\r\n[data-theme=\"dark\"] .challenge-dark-wrapper * {\r\n  box-shadow: none !important;\r\n  text-shadow: none !important;\r\n}\r\n\r\n.challenge-dark-wrapper {\r\n  font-size: 12px;\r\n  /* 부모(.history-challenge-tabs-content)는 flex column 인데 이 래퍼가 `flex: 0 1 auto` 라\r\n     **내용 높이만큼만** 차지했다 — 그래서 챌린지 화면 아래가 늘 비어 있었다(지적 2026-09-19).\r\n     안쪽은 이미 남는 높이를 나눠 갖게 돼 있으니, 여기서 높이를 열어 주면 지문도 같이 커진다. */\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n[data-theme=\"dark\"] .history-table { border-color: var(--color-border) !important; }\r\n[data-theme=\"dark\"] .history-list { border-color: var(--color-border) !important; }\r\n[data-theme=\"dark\"] .history-header-section { border-color: var(--color-border) !important; }\r\n\r\n/* 챌린지 파일 주고받기 버튼 — 툴바의 새로고침과 같은 높이·모양 */\r\n.challenge-file-btn {\r\n  height: 28px;\r\n  padding: 0 10px;\r\n  /* 글자가 두 줄로 꺾여 버튼이 찌그러지던 것 (신고 2026-09-19) */\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  background: var(--color-bg, #fff);\r\n  color: var(--color-text, #333);\r\n  border: 1px solid var(--color-border, #ddd);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.challenge-file-btn:hover { background: var(--color-hover, #f3f4f6); border-color: var(--color-accent, #3b82f6); }\r\n@media (prefers-reduced-motion: reduce) { .challenge-file-btn { transition: none; } }\r\n\r\n/* 챌린지 문제 출처 선택 — 툴바 버튼과 같은 높이 */\r\n.challenge-source-select {\r\n  height: 28px;\r\n  padding: 0 6px;\r\n  max-width: 140px;\r\n  flex-shrink: 0;\r\n  font-size: 11px;\r\n  background: var(--color-bg, #fff);\r\n  color: var(--color-text, #333);\r\n  border: 1px solid var(--color-border, #ddd);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: border-color 150ms ease;\r\n}\r\n.challenge-source-select:hover { border-color: var(--color-accent, #3b82f6); }\r\n@media (prefers-reduced-motion: reduce) { .challenge-source-select { transition: none; } }\r\n\r\n/* 챌린지 상단 도구 줄 — 좁아지면 **줄바꿈**하되 버튼 자체는 찌그러지지 않는다.\r\n   예전에는 한 줄에 밀어 넣어 「내보 내기」처럼 글자가 꺾였다. */\r\n.challenge-toolbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* ── 결과 표 — 열 고정 · 행 고정 (2026-10-01, utils/gridPin.js) ──\r\n   고정 열은 순번 칸(left:0, 30px) 뒤에 sticky 로 선다. 배경이 없으면 밑으로 지나가는 셀이 비친다. */\r\n.result-grid td.rg-pin-col,\r\n.result-grid th.rg-pin-col {\r\n  position: sticky;\r\n  background-color: var(--color-bg, #fff);\r\n}\r\n.result-grid td.rg-pin-col { z-index: 5; }\r\n.result-grid th.rg-pin-col { z-index: 22; background-color: var(--color-grid-header); }\r\n.result-grid .rg-pin-col-last { box-shadow: inset -2px 0 0 rgba(59, 130, 246, 0.55); }\r\n/* 고정 행 — 머리글 아래(top 은 인라인). 순번·고정 열과 겹치는 칸은 더 위에 */\r\n.result-grid tr.rg-pinned-row td {\r\n  position: sticky;\r\n  z-index: 8;\r\n  background-color: #fffbeb;\r\n}\r\n.result-grid tr.rg-pinned-row td.rg-pin-col { z-index: 21; }\r\n.result-grid tr.rg-pinned-row td:first-child { z-index: 24; color: #b45309 !important; background-color: #fef3c7 !important; }\r\n.result-grid tr.rg-pinned-row-last td { box-shadow: inset 0 -2px 0 rgba(217, 119, 6, 0.5); }\r\n/* 본문에서 고정된 행 — 순번만 표시(어디 있던 행인지 잃지 않게) */\r\n.result-grid tr.rg-row-pinned td:first-child { color: #b45309 !important; font-weight: 700; }\r\n[data-theme=\"dark\"] .result-grid td.rg-pin-col { background-color: var(--color-bg); }\r\n[data-theme=\"dark\"] .result-grid tr.rg-pinned-row td { background-color: #3a2f12; }\r\n[data-theme=\"dark\"] .result-grid tr.rg-pinned-row td:first-child { background-color: #4a3b12 !important; color: #fbbf24 !important; }\r\n[data-theme=\"dark\"] .result-grid tr.rg-row-pinned td:first-child { color: #fbbf24 !important; }\r\n\r\n/* 머리글 우클릭 메뉴 */\r\n.rg-header-menu {\r\n  position: fixed;\r\n  z-index: 1000;\r\n  min-width: 170px;\r\n  padding: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);\r\n  animation: rg-header-menu-in 140ms ease-out;\r\n}\r\n.rg-header-menu button {\r\n  text-align: left;\r\n  padding: 6px 10px;\r\n  border: none;\r\n  background: none;\r\n  border-radius: 4px;\r\n  font-size: 12.5px;\r\n  color: #1f2937;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease;\r\n}\r\n.rg-header-menu button:hover:not(:disabled) { background: #f3f4f6; }\r\n.rg-header-menu button:disabled { color: #9ca3af; cursor: default; }\r\n[data-theme=\"dark\"] .rg-header-menu { background: var(--color-bg-tertiary, #252526); border-color: var(--color-border, #3a3a3a); }\r\n[data-theme=\"dark\"] .rg-header-menu button { color: var(--color-text, #ddd); }\r\n[data-theme=\"dark\"] .rg-header-menu button:hover:not(:disabled) { background: var(--color-hover, #2a2d2e); }\r\n[data-theme=\"dark\"] .rg-header-menu button:disabled { color: var(--color-text-muted, #777); }\r\n@keyframes rg-header-menu-in {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .rg-header-menu { animation: none; }\r\n  .rg-header-menu button { transition: none; }\r\n}\r\n\r\n/* 트랜잭션 칩 — 미커밋 변경이 있을 때만(components/EditorToolbarRight.js TxnChip) */\r\n.txn-chip { padding: 1px 4px 1px 8px; border-radius: 6px; background: #fffbeb; border: 1px solid #fcd34d; animation: txn-chip-fade 160ms ease-out; }\r\n.txn-chip-label { display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #92400e; margin-right: 2px; }\r\n.txn-chip .txn-commit { color: #166534; }\r\n.txn-chip .txn-rollback { color: #b91c1c; }\r\n@keyframes txn-chip-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\r\n[data-theme=\"dark\"] .txn-chip { background: rgba(146, 64, 14, 0.25); border-color: #92400e; }\r\n[data-theme=\"dark\"] .txn-chip-label { color: #fde68a; }\r\n[data-theme=\"dark\"] .txn-chip .txn-commit { color: #86efac; }\r\n[data-theme=\"dark\"] .txn-chip .txn-rollback { color: #fca5a5; }\r\n@media (prefers-reduced-motion: reduce) { .txn-chip { animation: none; } }\r\n\r\n/* ── 결과 표 — 5행 띠 · 셀 범위 선택 (2026-10-07) ──\r\n   띠는 아주 옅게: 줄을 따라 읽을 때 눈이 미끄러지지 않을 만큼만. 선택은 utils/gridCopy.js(Ctrl+C = 탭 구분 복사) */\r\n/* 셀은 불투명한 색 — 표 밖 배경(회색)이 비치지 않게. 띠는 그 위에 아주 옅은 차이 */\r\n.result-grid tbody td { background-color: var(--color-bg, #fff); }\r\n.result-grid tr.rg-band td { background-color: #f8f9fb; }\r\n[data-theme=\"dark\"] .result-grid tr.rg-band td { background-color: #232323; }\r\n.result-grid tbody td { transition: background-color 120ms ease; }\r\n.result-grid tbody td.rg-sel {\r\n  background-color: rgba(59, 130, 246, 0.16) !important;\r\n}\r\n[data-theme=\"dark\"] .result-grid tbody td.rg-sel { background-color: rgba(96, 165, 250, 0.24) !important; }\r\n.result-grid:focus { outline: none; }\r\n.result-grid:focus-visible { outline: 1px solid rgba(59, 130, 246, 0.45); outline-offset: -1px; }\r\n[data-theme=\"dark\"] .result-grid td { border-color: #333; border-left-color: #2c2c2c; border-right-color: #2c2c2c; }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .result-grid tbody td { transition: none; }\r\n}\r\n/* 띠 규칙보다 뒤에 — 마우스 올린 행 강조가 띠에 가려지지 않게 */\r\n[data-theme=\"dark\"] .result-grid tbody tr:hover td:not(:first-child) { background-color: var(--color-hover); }\r\n\r\n/* 탭 닫기 알림의 「되돌리기」(2026-10-26) — 알림 글 옆 작은 단추 */\r\n.closed-tab-toast { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; }\r\n.closed-tab-undo { border: 1px solid currentColor; background: transparent; color: inherit; border-radius: 4px; padding: 1px 8px; font: inherit; font-weight: 600; cursor: pointer; transition: background-color 150ms ease; }\r\n.closed-tab-undo:hover { background: rgba(127, 127, 127, 0.18); }\r\n\n/* 결과 표 위의 열 필터 · 값 필터 (2026-10-29) — 한 줄, 걸려 있으면 강조 */\n.rg-filter-bar {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 4px;\n  font-size: 11px;\n  color: var(--color-text-muted, #6b7280);\n  min-width: 0;\n}\n.rg-filter-icon { flex: none; transition: color 150ms ease; }\n.rg-filter-on .rg-filter-icon { color: var(--color-accent, #3b82f6); }\n.rg-filter-input {\n  flex: 0 1 200px;\n  min-width: 80px;\n  height: 22px;\n  padding: 1px 6px;\n  font-size: 11px;\n  border: 1px solid var(--color-border, #d1d5db);\n  border-radius: 3px;\n  background: var(--color-bg, #fff);\n  color: var(--color-text, #222);\n  transition: border-color 150ms ease;\n}\n.rg-filter-input:focus { outline: none; border-color: var(--color-accent, #3b82f6); }\n.rg-filter-count {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  animation: rg-filter-fade 150ms ease-out;\n}\n.rg-filter-clear {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n  transition: background-color 150ms ease, color 150ms ease;\n}\n.rg-filter-clear:hover { background: var(--color-bg-tertiary, #e5e7eb); color: var(--color-text, #222); }\n@keyframes rg-filter-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\n@media (prefers-reduced-motion: reduce) {\n  .rg-filter-count { animation: none; }\n  .rg-filter-input, .rg-filter-clear, .rg-filter-icon { transition: none; }\n}\n\n/* 사용자 주석 열(2026-10-29) — 원래 컬럼 바로 오른쪽, 결과 값과 구별되게 엷은 바탕·기울임 */\n.rg-ucmt-status {\n  flex: none;\n  padding: 1px 6px;\n  border-radius: 8px;\n  font-size: 10.5px;\n  white-space: nowrap;\n  background: rgba(124, 58, 237, 0.10);\n  color: #6d28d9;\n  animation: rg-filter-fade 150ms ease-out;\n}\n.result-grid th.rg-ucmt-th { background: #f5f3ff; }\n.rg-ucmt-head { display: block; font-weight: 600; color: #6d28d9; }\n.rg-ucmt-head-src { display: block; font-size: 10px; font-weight: normal; color: #888; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.rg-ucmt-cell { font-style: italic; color: #5b21b6; }\n.rg-ucmt-pending { color: #aaa; }\n[data-theme=\"dark\"] .rg-ucmt-status { background: rgba(167, 139, 250, 0.16); color: #c4b5fd; }\n[data-theme=\"dark\"] .result-grid th.rg-ucmt-th { background: #2e2a3d; }\n[data-theme=\"dark\"] .rg-ucmt-head { color: #c4b5fd; }\n[data-theme=\"dark\"] .rg-ucmt-cell { color: #ddd6fe; }\n@media (prefers-reduced-motion: reduce) {\n  .rg-ucmt-status { animation: none; }\n}\n.rg-ucmt-toggle {\n  display: inline-flex; align-items: center; vertical-align: -1px;\n  margin-left: 4px; padding: 1px 2px; border: none; border-radius: 3px;\n  background: transparent; color: #8b5cf6; cursor: pointer;\n  transition: background-color 150ms ease, color 150ms ease;\n}\n.rg-ucmt-toggle:hover { background: rgba(124, 58, 237, 0.12); }\n.rg-ucmt-toggle.open { background: rgba(124, 58, 237, 0.18); color: #6d28d9; }\n[data-theme=\"dark\"] .rg-ucmt-toggle { color: #a78bfa; }\n[data-theme=\"dark\"] .rg-ucmt-toggle.open { background: rgba(167, 139, 250, 0.22); color: #ddd6fe; }\n.result-grid th.rg-ucmt-th .column-header-content { animation: rg-filter-fade 160ms ease-out; }\n@media (prefers-reduced-motion: reduce) {\n  .rg-ucmt-toggle { transition: none; }\n  .result-grid th.rg-ucmt-th .column-header-content { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
